$(document).ready(function() {
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      console.log('Enter key blocked globally')
    }
  }) 

  var one_tier_cake_flavour = false
  var cake_flavour_bottom_tier = false
  var cake_flavour_middle_tier = false
  var cake_flavour_top_tier = false
  var cake_flavour = false
  var cake_topper = false
  var cake_topper_option = ''
  var cake_topper_price = '' 
  var name = false
  var age = false
  var colour_swap = false
  var candles = false
  var display_same_topper_as_shown_on_cake = $('#display_same_topper_as_shown_on_cake').val() == 'Y' ? true : false 
  var same_topper_as_shown_on_cake_option = ''
  var text_on_board = false
  var text_on_board_no_gold = false 
  var cake_top_look = false
  var cake_top_look_full_moon_cake_topper = false
  var cake_top_look_half_moon_cake_topper = false
  var text_on_top_or_cake_topper = false
  var text_on_top_or_cake_topper_option_cake_topper = false
  var strawberries_and_chocolate_curls = false
  var sponge_cake_flavours = false
  var sponge_cake_fillings = false
  var buttercream_outside_colour = false
  var shell_edge_colour = false
  var sponge_cake_side_look = false
  var character_name = false
  var reference_picture = false
  var flowers = false
  var brand_of_choice = false
  var cake_team = false
  var cupcakes_flavour = false
  var cupcakes_text = false
  var cross = false
  var colour = false
  var front_plaque_text = false
  var cheese_cake_topping = false
  var cold_cheese_cake_topping = false
  var cake_drink_inspiration = false
  var cross_or_name = false
  var cake_image = false
  var cold_cheesecake_topping = false
  var disney_princess = false
  var image_on_top = false
  var text_on_top_or_cake_topper_text_with_no_colour = false
  var cake_flavour_milkshake = false
  var buttercream_colour_milkshake = false
  var birthday_buttercake_filling = false
  var chocolate_happy_birthday_plaque = false
  var text_on_top_or_cake_topper_with_text_printed = false
  var custom_image_cake_flavour = false
  var custom_image_cake_inside = false
  var photo_upload = false
  var teacake_flavour = false
  var picture_upload = false
  var colour_swirl = false
  var cupcake_theme_colour = false
  var hb_round_acrylic_toppers = false
  var cashews = false
  var glitter = false
  var gold_leaf = false
  var cannoli_fillings = false 
  var cannoli_colours = false 
  var cannoli_flowers = false
  var customised_mini_acrylic_name = false
  var drip = false
  var macarons = false
  var how_many_letters_or_numbers = false
  var letter_number_cake_flavour = false
  var letter_number_cake_filling = false
  var letter_number_cake_theme = false
  var letter_number_cake_flowers = false
  var customised_round_edible_image = false
  var mini_alcohol_bottles = false
  var letter_number_cake_customised_mini_acrylic_name = false
  var macarons_flavour = false
  var number_of_cookies = false
  var cookies_shape = false
  var cookies_stamp = false
  var cookies_theme = false
  var cookies_foil = false
  var harry_potter_house = false
  var dory_or_nemo = false
  var cooked_or_frozen = false
  var fondant_or_buttercream = false
  var gender_reveal_cupcake = false
  var gender_reveal_cake = false 
  var naked_cake_filling = false
  var minion_character = false

  // Other options
  var preparation_days = false  

  $('label:contains(Size)').text('PLEASE SELECT YOUR CAKE SIZE')   
  $('label:contains(SIZE)').text('PLEASE SELECT YOUR CAKE SIZE')   
  
  function cakeTopperPreselected(appendTo = '#custom-options') { 
    var cake_topper_template = `  
       <div id="cake_topper_option_container" class="product_option"> 
         <div class="cake-topper-customization">

          <p>NOTE: Please be aware that by adding a cake topper the earliest you will be able to select a pickup or delivery date would be 4 days from now, this in order to organise your custom cake topper to be made and delivered on time</p>
         
          <div> 
            <label for="cake_topper_options">What Cake Topper would you like?</label>
            <select name="cake_topper_options" id="cake_topper_options"> 
              <option value="">Please select</option>
              <option value="Cross [$10]">Cross ($10)</option>  
              <option value="Happy Birthday Topper [$30]">Happy Birthday Topper ($30)</option>
              ${same_topper_as_shown_on_cake_option} 
              <option value="Number Topper (Eg. 16) [$30]">Number Topper (Eg. 16) ($30)</option>
              <option value="Number Letter Topper (Eg. Sixteen) [$30]">Number Letter Topper (Eg. Sixteen) ($30)</option>
              <option value="Customised Cake Topper [$50]">Customised Cake Topper ($50)</option>
              <option value="Customised Acrylic Name and Age (For the front and or top of the cake) [$40]">Customised Acrylic Name and Age (For the front and or top of the cake) ($40)</option>
            </select>
          </div>

          <div class="topper-number" style="display:none;margin-top:12px;"> 
            <label for="topper_number">Number (Eg. 16)</label><br> 
            <input type="text" id="topper_number" name="topper_number" style="width:100%;">  
          </div>

          <div class="topper-number-text" style="display:none;margin-top:12px;"> 
            <label for="topper_number_text">Number (Eg. Sixteen)</label><br>
            <input type="text" id="topper_number_text" name="topper_number_text" maxlength="15" style="width:100%;">   
          </div>

          <div class="customised-topper-text" style="display:none;margin-top:12px;">
            <label for="customised_topper_text">What would you like the cake topper to say?</label><br>
            <input type="text" id="customised_topper_text" name="customised_topper_text" style="width:100%;"> 
          </div>

          <div class="customised-acrylic-text" style="display:none;margin-top:12px;">
            <label for="customised_acrylic_name">Name</label><br>
            <input type="text" id="customised_acrylic_name" name="customised_acrylic_name" maxlength="30" style="width:100%;">  
            <label for="customised_acrylic_age" style="margin-top:12px;">Age</label><br> 
            <input type="text" id="customised_acrylic_age" name="customised_acrylic_age" maxlength="2" style="width:100%;">
          </div>  

          <p class="customised-note" style="display:none;margin-top:10px;">NOTE: We will customised the cake topper to the best of our creative self in order to make this topper look awesome or classy in your cake</p> 

          <div class="cake-topper-colors" style="display:none;margin-top:12px;">   
            <label for="cake_topper_color">What colour would you like?</label>
            <select name="cake_topper_color" id="cake_topper_color"> 
              <option value="">Please select</option>
              <option value="Silver">Silver</option>
              <option value="Gold">Gold</option>
              <option value="White">White</option>
              <option value="Black">Black</option>
              <option value="Wood">Wood</option>  
            </select>
          </div>
        </div>
       </div>
     `
    if (appendTo == '#custom-options') {
      $(appendTo).append(cake_topper_template) 
    } else {  
      $(appendTo).after(cake_topper_template) 
    }

    cake_topper = true
    $('.cake-topper-customization').show() 

    $('#cake_topper_options').on('change', function() { 
      $('.cake-topper-colors').hide()
      $('.topper-number').hide()
      $('.topper-number-text').hide() 
      $('.customised-note').hide()
      $('.customised-topper-text').hide()
      $('.customised-acrylic-text').hide()

      cake_topper_option = this.value
      cake_topper_price = parseInt(cake_topper_option.substring(cake_topper_option.indexOf("$") + 1, cake_topper_option.lastIndexOf("]")))
      
      if (cake_topper_option != 'Customised Cake Topper [$50]' && cake_topper_option != 'Customised Acrylic Name and Age (For the front and or top of the cake) [$50]') { 
        $('.cake-topper-colors').show() 
      }

      if (cake_topper_option == 'Number Topper (Eg. 16) [$30]') {
        $('.topper-number').show()
      }

      if (cake_topper_option == 'Number Letter Topper (Eg. Sixteen) [$30]') { 
        $('.topper-number-text').show()
      }

      if (cake_topper_option == 'Customised Cake Topper [$50]' || cake_topper_option == 'Customised Acrylic Name and Age (For the front and or top of the cake) [$40]') { 
        $('.customised-note').show()
      }

      if (cake_topper_option == 'Customised Cake Topper [$50]') {
        $('.customised-topper-text').show() 
      }

      if (cake_topper_option == 'Customised Acrylic Name and Age (For the front and or top of the cake) [$40]') { 
        $('.customised-acrylic-text').show() 
      }
    })
    
  }
  
  function cakeTopper(appendTo = '#custom-options') {
    var cake_topper_template = `  
       <div id="cake_topper_option_container" class="product_option"> 
         <div>
           <label for="cake_topper_option">Would you like to add a Cake Topper?</label>
           <select name="cake_topper_option" id="cake_topper_option" class="is-required">
             <option value="">Please select</option>
             <option value="Yes, Please">Yes, Please</option>
             <option value="No, Thank You">No, Thank You</option>
           </select>
         </div>
         <div class="cake-topper-customization">

          <p>NOTE: Please be aware that by adding a cake topper the earliest you will be able to select a pickup or delivery date would be 4 days from now, this in order to organise your custom cake topper to be made and delivered on time</p>
         
          <div> 
            <label for="cake_topper_options">What Cake Topper would you like?</label>
            <select name="cake_topper_options" id="cake_topper_options"> 
              <option value="">Please select</option>
              <option value="Cross [$10]">Cross ($10)</option>  
              <option value="Happy Birthday Topper [$30]">Happy Birthday Topper ($30)</option>
              ${same_topper_as_shown_on_cake_option} 
              <option value="Number Topper (Eg. 16) [$30]">Number Topper (Eg. 16) ($30)</option>
              <option value="Number Letter Topper (Eg. Sixteen) [$30]">Number Letter Topper (Eg. Sixteen) ($30)</option>
              <option value="Customised Cake Topper [$50]">Customised Cake Topper ($50)</option>
              <option value="Customised Acrylic Name and Age (For the front and or top of the cake) [$40]">Customised Acrylic Name and Age (For the front and or top of the cake) ($40)</option>
            </select>
          </div>

          <div class="topper-number" style="display:none;margin-top:12px;"> 
            <label for="topper_number">Number (Eg. 16)</label><br> 
            <input type="text" id="topper_number" name="topper_number" style="width:100%;">  
          </div>

          <div class="topper-number-text" style="display:none;margin-top:12px;"> 
            <label for="topper_number_text">Number (Eg. Sixteen)</label><br>
            <input type="text" id="topper_number_text" name="topper_number_text" maxlength="15" style="width:100%;">   
          </div>

          <div class="customised-topper-text" style="display:none;margin-top:12px;">
            <label for="customised_topper_text">What would you like the cake topper to say?</label><br>
            <input type="text" id="customised_topper_text" name="customised_topper_text" style="width:100%;"> 
          </div>

          <div class="customised-acrylic-text" style="display:none;margin-top:12px;">
            <label for="customised_acrylic_name">Name</label><br>
            <input type="text" id="customised_acrylic_name" name="customised_acrylic_name" maxlength="30" style="width:100%;">  
            <label for="customised_acrylic_age" style="margin-top:12px;">Age</label><br> 
            <input type="text" id="customised_acrylic_age" name="customised_acrylic_age" maxlength="2" style="width:100%;">
          </div>  

          <p class="customised-note" style="display:none;margin-top:10px;">NOTE: We will customised the cake topper to the best of our creative self in order to make this topper look awesome or classy in your cake</p> 

          <div class="cake-topper-colors" style="display:none;margin-top:12px;">   
            <label for="cake_topper_color">What colour would you like?</label>
            <select name="cake_topper_color" id="cake_topper_color"> 
              <option value="">Please select</option>
              <option value="Silver">Silver</option>
              <option value="Gold">Gold</option>
              <option value="White">White</option>
              <option value="Black">Black</option>
              <option value="Wood">Wood</option>  
            </select>
          </div>
        </div>
       </div>
     `
    if (appendTo == '#custom-options') {
      $(appendTo).append(cake_topper_template) 
    } else {  
      $(appendTo).after(cake_topper_template) 
    }
    
    $('#cake_topper_option').on('change', function() { 
      $('.cake-topper-customization').hide()
      cake_topper = false
      if (this.value == 'Yes, Please') {
        cake_topper = true
        $('.cake-topper-customization').show()
      } else if (this.value == 'No, Thank You') {
        cake_topper = false
        $('.cake-topper-customization').hide()
      }
    })

    $('#cake_topper_options').on('change', function() { 
      $('.cake-topper-colors').hide()
      $('.topper-number').hide()
      $('.topper-number-text').hide() 
      $('.customised-note').hide()
      $('.customised-topper-text').hide()
      $('.customised-acrylic-text').hide()

      cake_topper_option = this.value
      cake_topper_price = parseInt(cake_topper_option.substring(cake_topper_option.indexOf("$") + 1, cake_topper_option.lastIndexOf("]")))
      
      if (cake_topper_option != 'Customised Cake Topper [$50]' && cake_topper_option != 'Customised Acrylic Name and Age (For the front and or top of the cake) [$50]') { 
        $('.cake-topper-colors').show() 
      }

      if (cake_topper_option == 'Number Topper (Eg. 16) [$30]') {
        $('.topper-number').show()
      }

      if (cake_topper_option == 'Number Letter Topper (Eg. Sixteen) [$30]') { 
        $('.topper-number-text').show()
      }

      if (cake_topper_option == 'Customised Cake Topper [$50]' || cake_topper_option == 'Customised Acrylic Name and Age (For the front and or top of the cake) [$40]') { 
        $('.customised-note').show()
      }

      if (cake_topper_option == 'Customised Cake Topper [$50]') {
        $('.customised-topper-text').show() 
      }

      if (cake_topper_option == 'Customised Acrylic Name and Age (For the front and or top of the cake) [$40]') { 
        $('.customised-acrylic-text').show() 
      }
    })
    
  }
  
  if (display_same_topper_as_shown_on_cake) {
    same_topper_as_shown_on_cake_option = '<option value="Same Topper as Shown on Cake [$50]">Same Topper as Shown on Cake ($50)</option>'
  }
  
  if ($('#number_of_cookies').val() == 'Y') { 
    number_of_cookies = true     
    $('#custom-options').append(` 
      <div id="number_of_cookies_option_container" class="product_option">
        <label for="number_of_cookies_option">How many cookies would you like?</label><br>
        <select id="number_of_cookies_option" name="number_of_cookie_options" class="is-required">
          <option value="">Please select</option>
          <option value="6 [$45]">6 ($45)</option>
          <option value="12 [$90]">12 ($90)</option>
          <option value="24 [$170]">24 ($170)</option>
          <option value="50 [$340]">50 ($340)</option> 
        </select>
      </div>
    `)
  }

  if ($('#cookies_shape').val() == 'Y') { 
    cookies_shape = true     
    $('#custom-options').append(` 
      <div id="cookies_shape_option_container" class="product_option">
        <label for="cookies_shape_option">What shape would your like your cookies?</label><br>
        <select id="cookies_shape_option" name="cookies_shape_option" class="is-required">
          <option value="">Please select</option>
          <option value="Round">Round</option>
          <option value="Square">Square</option>
          <option value="Hexagonal">Hexagonal</option>
          <option value="Baby Clothe">Baby Clothe</option>
          <option value="Heart">Heart</option> 
        </select>
      </div>
    `)
  }

  if ($('#cookies_stamp').val() == 'Y') { 
    cookies_stamp = true     
    $('#custom-options').append(` 
      <div id="cookies_stamp_option_container" class="product_option">
        <label for="cookies_stamp_option">What stamp would you like on the cookies?</label><br>
        <select id="cookies_stamp_option" name="cookies_stamp_option" class="is-required">
          <option value="">Please select</option>
          <option value="Happy Birthday">Happy Birthday</option>
          <option value="Love">Love</option>
          <option value="Future Mrs">Future Mrs</option>
          <option value="Happy Father's Day">Happy Father's Day</option>
          <option value="Happy Mother's Day">Happy Mother's Day</option>
          <option value="Thank You">Thank You</option>
          <option value="It's a Boy">It's a Boy</option>
          <option value="It's a Girl">It's a Girl</option>
          <option value="Oh Baby!">Oh Baby!</option>
          <option value="He or She?">He or She?</option>
          <option value="Custom Stamp [$35]">Custom Stamp ($35)</option>
        </select>
      </div>  
      <div id="cookies_stamp_image_option_container" class="product_option" style="display:none;"> 
        <label for="cookies_stamp_image_option">Please upload a sample of the custom stamp you would like</label>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">Note: We cant copy the exact same look, but we can create a similar one (Due to Copy Right reasons)</p>
        <input type="file" name="cookies_stamp_image_option" id="cookies_stamp_image_option" style="width:100%;"> 
      </div>
    `)

    $('#cookies_stamp_option').on('change', function() {      
      $('#cookies_stamp_image_option_container').hide() 
      
      if (this.value == 'Custom Stamp [$35]') { 
        $('#cookies_stamp_image_option_container').show()
      }  
    })
  }

  if ($('#cookies_theme').val() == 'Y') { 
    cookies_theme = true     
    $('#custom-options').append(` 
      <div id="cookies_theme_option_container" class="product_option"> 
        <label for="cookies_theme_option">Please explain here what colour/theme you want the cookies to look like</label><br>
        <input type="text" name="cookies_theme_option" id="cookies_theme_option" style="width:100%;" class="is-required">  
      </div>
    `)
  }

  if ($('#cookies_foil').val() == 'Y') { 
    cookies_foil = true     
    $('#custom-options').append(` 
      <div id="cookies_foil_option_container" class="product_option"> 
        <label for="cookies_foil_option">Would you like some gold/silver foil?</label><br>
        <select id="cookies_foil_option" name="cookies_foil_option" class="is-required">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="6 [$12]">6 ($12)</option> 
          <option value="12 [$22]">12 ($22)</option>
          <option value="24 [$40]">24 ($40)</option>
          <option value="50 [$80]">50 ($80)</option>
        </select>
      </div>
    `)
  }
  
  if ($('#cake_flavour').val() == 'Y') { 
    cake_flavour = true    
    $('#custom-options').append(` 
      <div id="cake_flavour_option_container" class="product_option">
        <label for="cake_flavour_flavour">Please select your buttercake flavour</label><br> 
        <select id="cake_flavour_flavour" name="cake_flavour_flavour" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
          <option value="Caramel & Chocolate Marble">Caramel & Chocolate Marble</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="White Chocolate & Caramel">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry">White Chocolate & Strawberry Marble</option>
          <option value="Red Velvet">Red Velvet</option>
          <option value="Lemon">Lemon</option>
          <option value="GF Vanilla [$25]">GF Vanilla [$25]</option>
          <option value="GF Chocolate [$25]">GF Chocolate [$25]</option>
          <option value="GF Vanilla & Chocolate Marble [$25]">GF Vanilla & Chocolate Marble [$25]</option>
          <option value="GF White Chocolate [$25]">GF White Chocolate [$25]</option> 
          <option value="GF White Chocolate & Caramel Marble [$25]">GF White Chocolate & Caramel Marble [$25]</option>
          <option value="GF White Chocolate & Strawberry Marble [$25]">GF White Chocolate & Strawberry Marble [$25]</option> 
        </select>
      </div>
    `)
  }
  
  if ($('#harry_potter_house').val() == 'Y') { 
    harry_potter_house = true    
    $('#custom-options').append(` 
      <div id="harry_potter_house_option_container" class="product_option">
        <label for="harry_potter_house_option">What Harry Potter house would you like?</label><br> 
        <select id="harry_potter_house_option" name="harry_potter_house_option" class="is-required">
          <option value="">Please select</option> 
          <option value="Gryffindor">Gryffindor</option>
          <option value="Hufflepuff">Hufflepuff</option>
          <option value="Ravenclaw">Ravenclaw</option>
          <option value="Slytherin">Slytherin</option>
        </select>
      </div>
    `)
  }

  if ($('#dory_or_nemo').val() == 'Y') {  
    dory_or_nemo = true    
    $('#custom-options').append(` 
      <div id="dory_or_nemo_option_container" class="product_option">
        <label for="dory_or_nemo_option">Dory or Nemo?</label><br> 
        <select id="dory_or_nemo_option" name="dory_or_nemo_option" class="is-required">
          <option value="">Please select</option> 
          <option value="Dory">Dory</option>
          <option value="Nemo">Nemo</option>
        </select>
      </div>
    `)
  }

  if ($('#birthday_buttercake_filling').val() == 'Y') { 
    birthday_buttercake_filling = true    
    $('#custom-options').append(` 
      <div id="birthday_buttercake_filling_option_container" class="product_option">
        <label for="birthday_buttercake_filling_option">Please select your filling</label><br> 
        <select id="birthday_buttercake_filling_option" name="birthday_buttercake_filling_option" class="is-required">
          <option value="">Please select</option>
          <option value="No Filling">No Filling</option>
          <option value="Vanilla Buttercream">Vanilla Buttercream</option>
          <option value="Chocolate Buttercream">Chocolate Buttercream</option>
          <option value="Chocolate Ganache">Chocolate Ganache</option>
          <option value="White Chocolate Truffle">White Chocolate Truffle</option>
        </select>
      </div>
    `)
  } 

  if ($('#naked_cake_filling').val() == 'Y') { 
    naked_cake_filling = true    
    $('#custom-options').append(` 
      <div id="naked_cake_filling_option_container" class="product_option">
        <label for="naked_cake_filling_option">Please select your filling</label><br> 
        <select id="naked_cake_filling_option" name="naked_cake_filling_option" class="is-required">
          <option value="">Please select</option> 
          <option value="Vanilla Buttercream">Vanilla Buttercream</option>
          <option value="Chocolate Buttercream">Chocolate Buttercream</option>
          <option value="Chocolate Ganache">Chocolate Ganache</option>
          <option value="White Chocolate Truffle">White Chocolate Truffle</option>
        </select>
      </div>
    `)
  } 
  
  if ($('#macarons_flavour').val() == 'Y') { 
    macarons_flavour = true
    $('#custom-options').append(`
      <div id="macarons_flavour_option_container" class="product_option">
        <label for="macarons_flavour_option">Flavour (colour) macarons</label><br> 
        <select id="macarons_flavour_option" name="macarons_flavour_option" class="is-required">
          <option value="">Please select</option>
          <option value="Mix Flavours">Mix Flavours</option>
          <option value="Chocolate (Dark Brown)">Chocolate (Dark Brown)</option>
          <option value="Caramel (Light Brown)">Caramel (Light Brown)</option>
          <option value="Strawberry (Pink)">Strawberry (Pink)</option>
          <option value="Pistachio (Green)">Pistachio (Green)</option>
          <option value="Blueberry (Blue)">Blueberry (Blue)</option>
          <option value="Vanilla Cupcake (Light Blue w Sprinkles)">Vanilla Cupcake (Light Blue w Sprinkles)</option>
          <option value="Mango (Yellow)">Mango (Yellow)</option>
          <option value="Passionfruit (Fuccia)">Passionfruit (Fuccia)</option>
          <option value="Oreo (White/Cream w Oreo)">Oreo (White/Cream w Oreo)</option>
          <option value="Brownie (Dark Brown w Nuts)">Brownie (Dark Brown w Nuts)</option>
        </select>
      </div> 
    `)
  }

  if ($('#how_many_letters_or_numbers').val() == 'Y') {
    how_many_letters_or_numbers = true
    $('#custom-options').append(`
      <div id="how_many_letters_or_numbers_option_container" class="product_option">
        <label for="how_many_letters_or_numbers_option">How many letters or numbers would you like?</label><br> 
        <select id="how_many_letters_or_numbers_option" name="how_many_letters_or_numbers_option" class="is-required">
          <option value="">Please select</option>
          <option value="One">One</option>
          <option value="Two [$90]">Two ($90)</option>
        </select>
      </div>

      <div id="letter_number_one_option_container" class="product_option" style="display:none">
        <label for="letter_number_one_option">Please select your first letter/number/symbol</label><br> 
        <select id="letter_number_one_option" name="letter_number_one_option">
          <option value="">Please select</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
          <option value="F">F</option>
          <option value="G">G</option>
          <option value="H">H</option>
          <option value="I">I</option>
          <option value="J">J</option>
          <option value="K">K</option>
          <option value="L">L</option>
          <option value="M">M</option>
          <option value="N">N</option>
          <option value="O">O</option>
          <option value="P">P</option>
          <option value="Q">Q</option>
          <option value="R">R</option>
          <option value="S">S</option>
          <option value="T">T</option>
          <option value="U">U</option>
          <option value="V">V</option>
          <option value="W">W</option>
          <option value="X">X</option>
          <option value="Y">Y</option>
          <option value="Z">Z</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="Heart">Heart</option>
          <option value="Cross">Cross</option>
        </select>
      </div>

      <div id="letter_number_two_option_container" class="product_option" style="display:none">
        <label for="letter_number_two_option">Please select your second letter/number/symbol</label><br> 
        <select id="letter_number_two_option" name="letter_number_two_option">
          <option value="">Please select</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
          <option value="F">F</option>
          <option value="G">G</option>
          <option value="H">H</option>
          <option value="I">I</option>
          <option value="J">J</option>
          <option value="K">K</option>
          <option value="L">L</option>
          <option value="M">M</option>
          <option value="N">N</option>
          <option value="O">O</option>
          <option value="P">P</option>
          <option value="Q">Q</option>
          <option value="R">R</option>
          <option value="S">S</option>
          <option value="T">T</option>
          <option value="U">U</option>
          <option value="V">V</option>
          <option value="W">W</option>
          <option value="X">X</option>
          <option value="Y">Y</option>
          <option value="Z">Z</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="Heart">Heart</option>
          <option value="Cross">Cross</option>
        </select>
      </div>
    `) 

    $('#how_many_letters_or_numbers_option').on('change', function() {     
      $('#letter_number_one_option_container').hide()
      $('#letter_number_two_option_container').hide()
      
      if (this.value == 'One') { 
        $('#letter_number_one_option_container').show()
      }  

      if (this.value == 'Two [$90]') { 
        $('#letter_number_one_option_container').show()
        $('#letter_number_two_option_container').show()
      } 
    })
  }

  if ($('#letter_number_cake_flavour').val() == 'Y') {
    letter_number_cake_flavour = true
    $('#custom-options').append(`
      <div id="letter_number_cake_flavour_option_container" class="product_option">
        <label for="letter_number_cake_flavour_option">Please select the base for your cake</label><br>  
        <select id="letter_number_cake_flavour_option" name="letter_number_cake_flavour_option" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla Sponge">Vanilla Sponge</option>
          <option value="Chocolate Sponge">Chocolate Sponge</option>
          <option value="Shortbread Cookie">Shortbread Cookie</option>
          <option value="Puff Pastry">Puff Pastry</option>
        </select>
      </div> 
    `)
  }

  if ($('#gender_reveal_cupcake').val() == 'Y') {
    gender_reveal_cupcake = true
    $('#custom-options').append(`
      <div id="gender_reveal_cupcake_option_container" class="product_option">
        <label for="gender_reveal_cupcake_option">Would you like colour filling for a gender reveal?</label><br>
        <select id="gender_reveal_cupcake_option" name="gender_reveal_cupcake_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$15]">Yes, Please ($15)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div> 

      <div id="gender_reveal_cupcake_colour_option_container" class="product_option" style="display:none;"> 
        <label for="gender_reveal_cupcake_colour_option">What colour would you like?</label><br>
        <select id="gender_reveal_cupcake_colour_option" name="gender_reveal_cupcake_colour_option">
          <option value="">Please select</option>
          <option value="Pink">Pink</option> 
          <option value="Blue">Blue</option>
        </select>
      </div> 
    `)

    $('#gender_reveal_cupcake_option').on('change', function() {     
      $('#gender_reveal_cupcake_colour_option_container').hide()
      
      if (this.value == 'Yes, Please [$15]') { 
        $('#gender_reveal_cupcake_colour_option_container').show() 
      }  
    })
  }
  
  if ($('#gender_reveal_cake').val() == 'Y') {
    gender_reveal_cake = true
    $('#custom-options').append(`
      <div id="gender_reveal_cake_option_container" class="product_option">
        <label for="gender_reveal_cake_option">Would you like colour filling for a gender reveal?</label><br>
        <select id="gender_reveal_cake_option" name="gender_reveal_cake_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$30]">Yes, Please ($30)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>  

      <div id="gender_reveal_cake_colour_option_container" class="product_option" style="display:none;"> 
        <label for="gender_reveal_cake_colour_option">What colour would you like?</label><br>
        <select id="gender_reveal_cake_colour_option" name="gender_reveal_cake_colour_option">
          <option value="">Please select</option>
          <option value="Pink">Pink</option> 
          <option value="Blue">Blue</option>
        </select>
      </div> 
    `)

    $('#gender_reveal_cake_option').on('change', function() {     
      $('#gender_reveal_cake_colour_option_container').hide()
      
      if (this.value == 'Yes, Please [$30]') {  
        $('#gender_reveal_cake_colour_option_container').show() 
      }  
    })
  }
  
  if ($('#letter_number_cake_filling').val() == 'Y') {
    letter_number_cake_filling = true
    $('#custom-options').append(`
      <div id="letter_number_cake_filling_option_container" class="product_option">
        <label for="letter_number_cake_filling_option">Please select your filling</label><br> 
        <select id="letter_number_cake_filling_option" name="letter_number_cake_filling_option" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla Buttercream">Vanilla Buttercream</option>
          <option value="Chocolate Buttercream">Chocolate Buttercream</option>
          <option value="Vanilla Custard Cream">Vanilla Custard Cream</option>
          <option value="Chocolate Custard Cream">Chocolate Custard Cream</option>
        </select>
      </div> 
    `)
  }

  if ($('#letter_number_cake_filling').val() == 'Y') {
    letter_number_cake_theme = true
    $('#custom-options').append(`
      <div id="letter_number_cake_theme_option_container" class="product_option">
        <label for="letter_number_cake_theme_option">Please explain your theme</label>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">
          Note: Explain here what colours and vibes are you looking for, we will work with lollies, pipping, lollies, edible images and some small fondant pieces to make the cake look stunning. Any Extras can be added bellow to make the look of the cake extra special
        </p> 
        <input type="text" id="letter_number_cake_theme_option" name="letter_number_cake_theme_option" style="width:100%;" class="is-required"> 
      </div> 
    `)
  }

  if ($('#customised_round_edible_image').val() == 'Y') {
    customised_round_edible_image = true
    $('#custom-options').append(`
      <div id="customised_round_edible_image_option_container" class="product_option">
        <label for="customised_round_edible_image_option">Would you like a customised 2" round edible image?</label><br> 
        <select id="customised_round_edible_image_option" name="customised_round_edible_image_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$10]">Yes, Please ($10)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>

      <div id="customised_round_edible_image_image_option_container" class="product_option" style="display:none;"> 
        <label for="customised_round_edible_image_image_option">Please upload your image here</label>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">NOTE: Please make sure to upload the imagine in the same shape for the cake you selected, as we dont modify images, we print straigh what you send.</p>
        <input type="file" name="customised_round_edible_image_image_option" id="customised_round_edible_image_image_option" style="width:100%;"> 
      </div>
    `)

    $('#customised_round_edible_image_option').on('change', function() {     
      $('#customised_round_edible_image_image_option_container').hide()
      
      if (this.value == 'Yes, Please [$10]') { 
        $('#customised_round_edible_image_image_option_container').show()
      }  
    })
  }

  if ($('#letter_number_cake_customised_mini_acrylic_name').val() == 'Y') {
    letter_number_cake_customised_mini_acrylic_name = true 
    $('#custom-options').append(`
      <div id="letter_number_cake_customised_mini_acrylic_name_option_container" class="product_option">
        <label for="letter_number_cake_customised_mini_acrylic_name_option">Would you like a customised mini acrylic name?</label><br> 
        <select id="letter_number_cake_customised_mini_acrylic_name_option" name="letter_number_cake_customised_mini_acrylic_name_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$15]">Yes, Please ($15)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>

      <div id="customised_mini_acrylic_name_text_option_container" class="product_option" style="display:none;"> 
        <label for="customised_mini_acrylic_name_text_option">Mini acrylic name to read</label><br>
        <input type="text" name="customised_mini_acrylic_name_text_option" id="customised_mini_acrylic_name_text_option" style="width:100%;"> 
      </div>
    `)

    $('#letter_number_cake_customised_mini_acrylic_name_option').on('change', function() {   
      $('#customised_mini_acrylic_name_text_option_container').hide()

      if (this.value == 'Yes, Please [$15]') { 
        $('#customised_mini_acrylic_name_text_option_container').show()
      }
    })
  }
  
  if ($('#cake_flavour_milkshake').val() == 'Y') {
    cake_flavour_milkshake = true
    $('#custom-options').append(`
      <div id="cake_flavour_milkshake_option_container" class="product_option">
        <label for="cake_flavour_milkshake_option">Please select your buttercake flavour</label><br> 
        <select id="cake_flavour_milkshake_option" name="cake_flavour_milkshake_option" class="is-required">
          <option value="">Please select</option>
          <option value="White Chocolate & Caramel Marble">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry Marble">White Chocolate & Strawberry Marble</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
        </select>
      </div>
    `)
  }

  if ($('#buttercream_colour_milkshake').val() == 'Y') {
    buttercream_colour_milkshake = true
    $('#custom-options').append(`
      <div id="buttercream_colour_milkshake_option_container" class="product_option">
        <label for="buttercream_colour_milkshake_option">Please select the outside buttercream colour</label><br> 
        <select id="buttercream_colour_milkshake_option" name="buttercream_colour_milkshake_option" class="is-required">
          <option value="">Please select</option>
          <option value="Baby Blue">Baby Blue</option>
          <option value="Baby Green">Baby Green</option>
          <option value="Baby Pink">Baby Pink</option>
          <option value="Baby Purple">Baby Purple</option>
          <option value="Baby Yellow">Baby Yellow</option>
          <option value="White">White</option>
        </select>
      </div>
    `)
  } 

  if ($('#cheese_cake_topping').val() == 'Y') {
    cheese_cake_topping = true
    $('#custom-options').append(`
      <div id="cheese_cake_topping_option_container" class="product_option">
        <label for="cheese_cake_topping_option">What topping would you like?</label><br> 
        <select id="cheese_cake_topping_option" name="cheese_cake_topping_option" class="is-required">
          <option value="">Please select</option>
          <option value="Raspberry">Raspberry</option> 
          <option value="Chocolate">Chocolate</option>
          <option value="Blueberry">Blueberry</option>
          <option value="Plain">Plain</option>
        </select>
      </div>
    `)
  }

  if ($('#cold_cheesecake_topping').val() == 'Y') {
    cold_cheese_cake_topping = true
    $('#custom-options').append(`
      <div id="cold_cheesecake_topping_option_container" class="product_option">
        <label for="cold_cheesecake_topping_option">What topping would you like?</label><br> 
        <select id="cold_cheesecake_topping_option" name="cold_cheesecake_topping_option" class="is-required">
          <option value="">Please select</option>
          <option value="Cookies & Cream">Cookies & Cream</option>
          <option value="Bueno">Bueno</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Biscoff">Biscoff</option>
          <option value="Caramilk">Caramilk</option>
          <option value="Citrus">Citrus</option>
          <option value="Plain">Plain</option> 
        </select>
      </div>
    `)
  }

  if ($('#sponge_cake_flavours').val() == 'Y') {
    sponge_cake_flavours = true

    $('#custom-options').append(`
      <div id="sponge_cake_flavours_option_container" class="product_option">
        <label for="sponge_cake_flavours_option">Please select your flavour</label><br> 
        <select id="sponge_cake_flavours_option" name="sponge_cake_flavours_option" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla Sponge">Vanilla Sponge</option>
          <option value="Chocolate Sponge">Chocolate Sponge</option>
        </select> 
      </div>
    `) 
  }

  if ($('#sponge_cake_fillings').val() == 'Y') {
    sponge_cake_fillings = true

    $('#custom-options').append(`
      <div id="sponge_cake_sponge_cake_fillings_option_container" class="product_option">
        <label for="sponge_cake_sponge_cake_fillings_option">Please select your filling</label><br>  
        <select id="sponge_cake_sponge_cake_fillings_option" name="sponge_cake_sponge_cake_fillings_option" class="is-required">
          <option value="">Please select</option>
          <option value="Jam & Fresh Cream">Jam & Fresh Cream</option>
          <option value="Jam & Butter Cream">Jam & Butter Cream</option>
          <option value="Fresh Cream">Fresh Cream</option>
          <option value="Vanilla Custard & Fresh Cream">Vanilla Custard & Fresh Cream</option>
          <option value="Vanilla Custard">Vanilla Custard</option>
          <option value="Chocolate Custard & Fresh Cream">Chocolate Custard & Fresh Cream</option>
          <option value="Chocolate Custard">Chocolate Custard</option>
        </select> 
      </div> 
    `) 
  }

  if ($('#buttercream_outside_colour').val() == 'Y') {
    buttercream_outside_colour = true

    $('#custom-options').append(`
      <div id="buttercream_outside_colour_option_container" class="product_option">
        <label for="buttercream_outside_colour_option">Please select your buttercream outside colour</label><br>  
        <select id="buttercream_outside_colour_option" name="buttercream_outside_colour_option" class="is-required">
          <option value="">Please select</option>
          <option value="White (Vanilla)">White (Vanilla)</option>
          <option value="Light Brown (Chocolate)">Light Brown (Chocolate)</option>
          <option value="Colour [$10]">Colour ($10)</option>
        </select> 
      </div>

      <div id="buttercream_outside_colour_colour_option_container" class="product_option" style="display:none;">
        <label for="buttercream_outside_colour_colour_option">Buttercream Colour</label><br>  
        <input type="color" id="buttercream_outside_colour_colour_option" name="buttercream_outside_colour_colour_option" value="#ffffff">  
      </div>
    `) 

    $('#buttercream_outside_colour_option').on('change', function() {   
      $('#buttercream_outside_colour_colour_option_container').hide() 
      
      if (this.value == 'Colour [$10]') { 
        $('#buttercream_outside_colour_colour_option_container').show() 
      } 
    })
  }

  if ($('#shell_edge_colour').val() == 'Y') {
    shell_edge_colour = true

    $('#custom-options').append(`
      <div id="shell_edge_colour_option_container" class="product_option">
        <label for="shell_edge_colour_option">Please select your shell edge colour</label><br>  
        <select id="shell_edge_colour_option" name="shell_edge_colour_option" class="is-required">
          <option value="">Please select</option>
          <option value="White (Vanilla)">White (Vanilla)</option>
          <option value="Light Brown (Chocolate)">Light Brown (Chocolate)</option>
          <option value="Same as outside colour">Same as outside colour</option> 
          <option value="Please match it nicely to the cake themed [$10]">Please match it nicely to the cake themed ($10)</option>
          <option value="Colour [$10]">Colour ($10)</option>
        </select> 
      </div> 

      <div id="shell_edge_colour_colour_option_container" class="product_option" style="display:none;">
        <label for="shell_edge_colour_colour_option">Shell Edge Colour</label><br>   
        <input type="color" id="shell_edge_colour_colour_option" name="shell_edge_colour_colour_option" value="#ffffff">  
      </div>
    `) 

    $('#shell_edge_colour_option').on('change', function() {     
      $('#shell_edge_colour_colour_option_container').hide() 
      
      if (this.value == 'Colour [$10]') { 
        $('#shell_edge_colour_colour_option_container').show() 
      } 
    })
  }

  if ($('#sponge_cake_side_look').val() == 'Y') {
    sponge_cake_side_look = true

    $('#custom-options').append(`
      <div id="sponge_cake_side_look_option_container" class="product_option">
        <label for="sponge_cake_side_look_option">Please select the side look</label><br>  
        <select id="sponge_cake_side_look_option" name="sponge_cake_side_look_option" class="is-required">
          <option value="">Please select</option>
          <option value="Spack Finish (This will be on the same colour buttercream as the outside colour selected)">Spack Finish (This will be on the same colour buttercream as the outside colour selected)</option>
          <option value="Combed Finish (This will be on the same colour buttercream as the outside colour selected)">Combed Finish (This will be on the same colour buttercream as the outside colour selected)</option>
          <option value="Smooth Finish (This will be on the same colour buttercream as the outside colour selected) [$20]">Smooth Finish (This will be on the same colour buttercream as the outside colour selected) ($20)</option>
          <option value="Toasted Coconut [$5]">Toasted Coconut ($5)</option>
          <option value="Almond Flakes [$10]">Almond Flakes ($10)</option> 
          <option value="Crushed Oreos [$10]">Crushed Oreos ($10)</option>
          <option value="Grated Chocolate [$5]">Grated Chocolate ($5)</option>
          <option value="Sprinkles">Sprinkles</option>
        </select> 
      </div>  

      <div id="shell_edge_colour_sprinkles_option_container" class="product_option" style="display:none;">
        <label for="shell_edge_colour_sprinkles_option">Please select colour sprinkles</label><br>  
        <select id="shell_edge_colour_sprinkles_option" name="shell_edge_colour_sprinkles_option">
          <option value="">Please select</option>
          <option value="Multicolour">Multicolour</option>
          <option value="Pink">Pink</option>
          <option value="Yellow">Yellow</option>
          <option value="Orange">Orange</option>
          <option value="Green">Green</option>
          <option value="Red">Red</option>
          <option value="Blue">Blue</option>
          <option value="100s & 1000s">100s & 1000s</option>
          <option value="Bright Confetti [$10]">Bright Confetti ($10)</option>
          <option value="Pastel Confetti [$10]">Pastel Confetti ($10)</option>
          <option value="Mix Sprinkles [$10]">Mix Sprinkles ($10)</option>
        </select> 
      </div>

      <div id="shell_edge_colour_sprinkles_sprinkles_one_option_container" class="product_option" style="display:none;">
        <label for="shell_edge_colour_sprinkles_sprinkles_one_option">Sprinkles Colour 1</label><br>  
        <select id="shell_edge_colour_sprinkles_sprinkles_one_option" name="shell_edge_colour_sprinkles_sprinkles_one_option">
          <option value="">Please select</option>
          <option value="Pink">Pink</option>
          <option value="Yellow">Yellow</option>
          <option value="Orange">Orange</option>
          <option value="Green">Green</option>
          <option value="Red">Red</option>
          <option value="Blue">Blue</option>
        </select> 
      </div>

      <div id="shell_edge_colour_sprinkles_sprinkles_two_option_container" class="product_option" style="display:none;">
        <label for="shell_edge_colour_sprinkles_sprinkles_two_option">Sprinkles Colour 2</label><br>  
        <select id="shell_edge_colour_sprinkles_sprinkles_two_option" name="shell_edge_colour_sprinkles_sprinkles_two_option">
          <option value="">Please select</option>
          <option value="Pink">Pink</option>
          <option value="Yellow">Yellow</option>
          <option value="Orange">Orange</option>
          <option value="Green">Green</option>
          <option value="Red">Red</option>
          <option value="Blue">Blue</option>
        </select> 
      </div>
    `)

    $('#sponge_cake_side_look_option').on('change', function() {      
      $('#shell_edge_colour_sprinkles_option_container').hide() 
      
      if (this.value == 'Sprinkles') { 
        $('#shell_edge_colour_sprinkles_option_container').show() 
      } 
    }) 

    $('#shell_edge_colour_sprinkles_option').on('change', function() {       
      $('#shell_edge_colour_sprinkles_sprinkles_one_option_container').hide()
      $('#shell_edge_colour_sprinkles_sprinkles_two_option_container').hide()
      
      if (this.value == 'Mix Sprinkles [$10]') {  
        $('#shell_edge_colour_sprinkles_sprinkles_one_option_container').show()
        $('#shell_edge_colour_sprinkles_sprinkles_two_option_container').show()
      } 
    })
  }

  if ($('#text_on_top_or_cake_topper_text_with_no_colour').val() == 'Y') {
    text_on_top_or_cake_topper_text_with_no_colour = true
    $('#custom-options').append(`
      <div id="text_on_top_or_cake_topper_nc_option_container" class="product_option">
        <label for="text_on_top_or_cake_topper_nc_option">Would you like to add text on top or a cake topper?</label><br> 
        <select id="text_on_top_or_cake_topper_nc_option" name="text_on_top_or_cake_topper_nc_option" class="is-required">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Text On The Cake">Text On The Cake</option>
          <option value="Cake Topper">Cake Topper</option>
        </select> 
      </div>
      
      <div id="text_on_top_or_cake_topper_nc_text_on_cake_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_nc_text_on_cake_option">Please add your text bellow</label><br> 
        <input type="text" id="text_on_top_or_cake_topper_nc_text_on_cake_option" name="text_on_top_or_cake_topper_nc_text_on_cake_option" style="width:100%;"> 
      </div> 
    `) 

    $('#text_on_top_or_cake_topper_nc_option').on('change', function() {    
      $('#text_on_top_or_cake_topper_nc_text_on_cake_option_container').hide()  
      
      if (this.value == 'Cake Topper' && text_on_top_or_cake_topper_nc_option != true) { 
        text_on_top_or_cake_topper_option_cake_topper = true
        cakeTopperPreselected('#text_on_top_or_cake_topper_nc_option_container')  
      } else if (this.value == 'Text On The Cake') {
        if (text_on_top_or_cake_topper_option_cake_topper == true) {
          text_on_top_or_cake_topper_option_cake_topper = false
          cake_topper = false
          $('#cake_topper_option_container').remove() 
        } 

        $('#text_on_top_or_cake_topper_nc_text_on_cake_option_container').show() 
      } else if (text_on_top_or_cake_topper_option_cake_topper == true) {
        text_on_top_or_cake_topper_option_cake_topper = false 
        cake_topper = false
        $('#cake_topper_option_container').remove() 
      }  
    })
  }

  if ($('#text_on_top_or_cake_topper_with_text_printed').val() == 'Y') {
    text_on_top_or_cake_topper_with_text_printed = true
    $('#custom-options').append(`
      <div id="text_on_top_or_cake_topper_with_text_printed_option_container" class="product_option">
        <label for="text_on_top_or_cake_topper_with_text_printed_option">Would you like to add text on top or a cake topper?</label><br> 
        <select id="text_on_top_or_cake_topper_with_text_printed_option" name="text_on_top_or_cake_topper_with_text_printed_option" class="is-required">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Text On The Cake">Text On The Cake</option>
          <option value="Text Printed On Image">Text Printed On Image</option>
          <option value="Cake Topper">Cake Topper</option>
        </select> 
      </div>

      <div id="text_on_top_or_cake_topper_chocolate_or_colour_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_chocolate_or_colour_option">Chocolate or colour</label><br> 
        <select id="text_on_top_or_cake_topper_chocolate_or_colour_option" name="text_on_top_or_cake_topper_chocolate_or_colour_option">
          <option value="">Please select</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Colour [$10]">Colour ($10)</option>
        </select>  
      </div> 

      <div id="text_on_top_or_cake_topper_colour_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_colour_option">Please add your text bellow</label><br> 
        <input type="color" id="text_on_top_or_cake_topper_colour_option" name="text_on_top_or_cake_topper_colour_option" value="#ffffff"> 
      </div>
      
      <div id="text_on_top_or_cake_topper_text_on_cake_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_text_on_cake_option">Please add your text bellow</label><br> 
        <input type="text" id="text_on_top_or_cake_topper_text_on_cake_option" name="text_on_top_or_cake_topper_text_on_cake_option" style="width:100%;"> 
      </div>
    `)

    $('#text_on_top_or_cake_topper_with_text_printed_option').on('change', function() {   
      $('#text_on_top_or_cake_topper_text_on_cake_option_container').hide()
      $('#text_on_top_or_cake_topper_chocolate_or_colour_option_container').hide()
      $('#text_on_top_or_cake_topper_colour_option_container').hide() 
      
      if (this.value == 'Cake Topper' && text_on_top_or_cake_topper_option_cake_topper != true) { 
        text_on_top_or_cake_topper_option_cake_topper = true
        cakeTopperPreselected('#text_on_top_or_cake_topper_with_text_printed_option_container')
      } else if (this.value == 'Text Printed On Image') {
        if (text_on_top_or_cake_topper_option_cake_topper == true) {
          text_on_top_or_cake_topper_option_cake_topper = false
          cake_topper = false 
          $('#cake_topper_option_container').remove()  
        }    
        
        $('#text_on_top_or_cake_topper_text_on_cake_option_container').show()
      } else if (this.value == 'Text On The Cake') {
        if (text_on_top_or_cake_topper_option_cake_topper == true) {
          text_on_top_or_cake_topper_option_cake_topper = false
          cake_topper = false
          $('#cake_topper_option_container').remove() 
        }   

        $('#text_on_top_or_cake_topper_chocolate_or_colour_option_container').show()
        $('#text_on_top_or_cake_topper_text_on_cake_option_container').show() 
      } else if (text_on_top_or_cake_topper_option_cake_topper == true) {
        text_on_top_or_cake_topper_option_cake_topper = false 
        cake_topper = false
        $('#cake_topper_option_container').remove() 
      }  
    })

    $('#text_on_top_or_cake_topper_chocolate_or_colour_option').on('change', function() {
      $('#text_on_top_or_cake_topper_colour_option_container').hide()

      if (this.value == 'Colour [$10]') { 
        $('#text_on_top_or_cake_topper_colour_option_container').show()
      }
    })
  }
  
  if ($('#text_on_top_or_cake_topper').val() == 'Y') {
    text_on_top_or_cake_topper = true
    $('#custom-options').append(`
      <div id="text_on_top_or_cake_topper_option_container" class="product_option">
        <label for="text_on_top_or_cake_topper_option">Would you like to add text on top or a cake topper?</label><br> 
        <select id="text_on_top_or_cake_topper_option" name="text_on_top_or_cake_topper_option" class="is-required">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Text On The Cake">Text On The Cake</option>
          <option value="Cake Topper">Cake Topper</option>
        </select> 
      </div>

      <div id="text_on_top_or_cake_topper_chocolate_or_colour_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_chocolate_or_colour_option">Chocolate or colour</label><br> 
        <select id="text_on_top_or_cake_topper_chocolate_or_colour_option" name="text_on_top_or_cake_topper_chocolate_or_colour_option">
          <option value="">Please select</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Colour [$10]">Colour ($10)</option>
        </select>  
      </div> 

      <div id="text_on_top_or_cake_topper_colour_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_colour_option">Colour</label><br>  
        <input type="color" id="text_on_top_or_cake_topper_colour_option" name="text_on_top_or_cake_topper_colour_option" value="#ffffff">   
      </div> 
      
      <div id="text_on_top_or_cake_topper_text_on_cake_option_container" class="product_option" style="display:none;">
        <label for="text_on_top_or_cake_topper_text_on_cake_option">Please add your text bellow</label><br> 
        <input type="text" id="text_on_top_or_cake_topper_text_on_cake_option" name="text_on_top_or_cake_topper_text_on_cake_option" style="width:100%;"> 
      </div>
    `)

    $('#text_on_top_or_cake_topper_option').on('change', function() {   
      $('#text_on_top_or_cake_topper_text_on_cake_option_container').hide()
      $('#text_on_top_or_cake_topper_chocolate_or_colour_option_container').hide()
      $('#text_on_top_or_cake_topper_colour_option_container').hide() 
      
      if (this.value == 'Cake Topper' && text_on_top_or_cake_topper_option_cake_topper != true) { 
        text_on_top_or_cake_topper_option_cake_topper = true
        cakeTopperPreselected('#text_on_top_or_cake_topper_option_container')  
      } else if (this.value == 'Text On The Cake') {
        if (text_on_top_or_cake_topper_option_cake_topper == true) {
          text_on_top_or_cake_topper_option_cake_topper = false
          cake_topper = false
          $('#cake_topper_option_container').remove() 
        }  

        $('#text_on_top_or_cake_topper_chocolate_or_colour_option_container').show()
        $('#text_on_top_or_cake_topper_text_on_cake_option_container').show() 
      } else if (text_on_top_or_cake_topper_option_cake_topper == true) {
        text_on_top_or_cake_topper_option_cake_topper = false
        cake_topper = false
        $('#cake_topper_option_container').remove() 
      }  
    })

    $('#text_on_top_or_cake_topper_chocolate_or_colour_option').on('change', function() {
      $('#text_on_top_or_cake_topper_colour_option_container').hide()

      if (this.value == 'Colour [$10]') {  
        $('#text_on_top_or_cake_topper_colour_option_container').show()
      }
    })
  }

  if ($('#strawberries_and_chocolate_curls').val() == 'Y') {
    strawberries_and_chocolate_curls = true
    $('#custom-options').append(`
      <div id="strawberries_and_chocolate_curls_option_container" class="product_option">
        <label for="strawberries_and_chocolate_curls_option">Would you like to strawberries and chocolate curls on top?</label><br> 
        <select id="strawberries_and_chocolate_curls_option" name="strawberries_and_chocolate_curls_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select> 
      </div> 
    `)
  }

  if ($('#cake_top_look').val() == 'Y') {
    cake_top_look = true
    $('#custom-options').append(`
      <div id="cake_top_look_option_container" class="product_option">
        <label for="cake_top_look_option">Please select the look for the top of the cake</label><br> 
        <select id="cake_top_look_option" name="cake_top_look_option" class="is-required">
          <option value="">Please select</option>
          <option value="Full Moon">Full Moon</option>
          <option value="Half Moon">Half Moon</option>
        </select>
      </div>

      <div id="cake_top_look_full_moon_option_container" class="product_option" style="display:none;">
        <label for="cake_top_look_full_moon_option">Would you like a HB chocolate sign or a cake topper?</label><br> 
        <select id="cake_top_look_full_moon_option" name="cake_top_look_full_moon_option">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Chocolate Sign [$5]">Chocolate Sign ($5)</option>
          <option value="Cake Topper">Cake Topper</option>
        </select>
      </div>

      <div id="cake_top_look_half_moon_option_container" class="product_option" style="display:none;">
        <label for="cake_top_look_half_moon_option">Would you like to add text on top or a cake topper?</label><br> 
        <select id="cake_top_look_half_moon_option" name="cake_top_look_half_moon_option">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Text On The Cake">Text On The Cake</option>
          <option value="Cake Topper">Cake Topper</option>
        </select>
      </div>

      <div id="cake_top_look_text_on_cake_option_container" class="product_option" style="display:none;">
        <label for="cake_top_look_text_on_cake_option">Please add your text bellow</label><br> 
        <input type="text" id="cake_top_look_text_on_cake_option" name="cake_top_look_text_on_cake_option" style="width:100%;"> 
      </div>
    `)

    $('#cake_top_look_option').on('change', function() {  
      $('#cake_top_look_full_moon_option_container').hide()
      $('#cake_top_look_half_moon_option_container').hide()
      $('#cake_top_look_text_on_cake_option_container').hide() 
      $('#cake_topper_option_container').remove()  
      
      if (this.value == 'Full Moon') {
        $('#cake_top_look_full_moon_option_container').show()
      } else if (this.value == 'Half Moon') {
        $('#cake_top_look_half_moon_option_container').show() 
      }
    })

    $('#cake_top_look_full_moon_option').on('change', function() {
      if (this.value == 'Cake Topper' && cake_top_look_full_moon_cake_topper != true) { 
        cake_top_look_full_moon_cake_topper = true 
        cakeTopperPreselected('#cake_top_look_full_moon_option_container') 
      } else {   
        cake_top_look_full_moon_cake_topper = false
        cake_topper = false
        $('#cake_topper_option_container').remove() 
      } 
    })

    $('#cake_top_look_half_moon_option').on('change', function() {
      $('#cake_top_look_text_on_cake_option_container').hide() 
      
      if (this.value == 'Cake Topper' && cake_top_look_half_moon_cake_topper != true) { 
        cake_top_look_half_moon_cake_topper = true
        cakeTopperPreselected('#cake_top_look_half_moon_option_container') 
      } else if (this.value == 'Text On The Cake') {
        if (cake_top_look_half_moon_cake_topper == true) {
          cake_top_look_half_moon_cake_topper = false
          cake_topper = false
          $('#cake_topper_option_container').remove() 
        }

        $('#cake_top_look_text_on_cake_option_container').show()
      } else if (cake_top_look_half_moon_cake_topper == true) {
        cake_top_look_half_moon_cake_topper = false
        cake_topper = false
        $('#cake_topper_option_container').remove() 
      }  
    }) 
  }

  if ($('#custom_image_cake_flavour').val() == 'Y') {
    custom_image_cake_flavour = true    
    $('#custom-options').append(` 
      <div id="custom_image_cake_flavour_option_container" class="product_option">
        <label for="custom_image_cake_flavour_option">Please select your buttercake flavour</label><br> 
        <select id="custom_image_cake_flavour_option" name="custom_image_cake_flavour_option" class="is-required">
          <option value="">Please select</option>
          <option value="Chocolate (With Layers of Chocolate Ganache)">Chocolate (With Layers of Chocolate Ganache)</option>
          <option value="Vanilla (With Layers of Biscoff Buttercream)">Vanilla (With Layers of Biscoff Buttercream)</option>
          <option value="White Chocolate & Strawberry Marble (With Layers of Strawberry and Vanilla Buttercream)">White Chocolate & Strawberry Marble (With Layers of Strawberry and Vanilla Buttercream)</option>
          <option value="Vanilla & Chocolate Marble (With Layers of Chocolate Ganache and Vanilla Buttercream)">Vanilla & Chocolate Marble (With Layers of Chocolate Ganache and Vanilla Buttercream)</option>
          <option value="White Chocolate & Caramel Marble (With Layers of Caramel and Vanilla Buttercream)">White Chocolate & Caramel Marble (With Layers of Caramel and Vanilla Buttercream)</option>
        </select>
      </div>
    `)
  }

  if ($('#custom_image_cake_inside').val() == 'Y') {
    custom_image_cake_inside = true    
    $('#custom-options').append(` 
      <div id="custom_image_cake_inside_option_container" class="product_option">
        <label for="custom_image_cake_inside_option">Please select the look on the side of the cake</label><br> 
        <select id="custom_image_cake_inside_option" name="custom_image_cake_inside_option" class="is-required">
          <option value="">Please select</option>
          <option value="White Buttercream (Spack finish)">White Buttercream (Spack finish)</option>
          <option value="100s & 1000s">100s & 1000s</option>
          <option value="Pink Sprinkles">Pink Sprinkles</option>
          <option value="Blue Sprinkles">Blue Sprinkles</option>
        </select>
      </div> 
    `)
  }

  if ($('#teacake_flavour').val() == 'Y') {
    teacake_flavour = true    
    $('#custom-options').append(` 
      <div id="teacake_flavour_option_container" class="product_option">
        <label for="teacake_flavour_option">What flavour teacake would you like?</label><br> 
        <select id="teacake_flavour_option" name="teacake_flavour_option" class="is-required">
          <option value="">Please select</option>
          <option value="Apple">Apple</option>
          <option value="Blueberry">Blueberry</option>
          <option value="Caramel & Walnuts">Caramel & Walnuts</option>
        </select>
      </div>
    `)
  }
  
  if ($('#cake_flavour_top_tier').val() == 'Y') {
    cake_flavour_top_tier = true   
    $('#custom-options').append(` 
      <div id="cake_flavour_top_tier_option_container" class="product_option">
        <label for="cake_flavour_top_tier_flavour">Please select your buttercake flavour - top tier</label><br> 
        <select id="cake_flavour_top_tier_flavour" name="cake_flavour_top_tier_flavour" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
          <option value="Caramel & Chocolate Marble">Caramel & Chocolate Marble</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="White Chocolate & Caramel">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry">White Chocolate & Strawberry Marble</option>
          <option value="Red Velvet">Red Velvet</option>
          <option value="Lemon">Lemon</option>
          <option value="GF Vanilla [$25]">GF Vanilla [$25]</option>
          <option value="GF Chocolate [$25]">GF Chocolate [$25]</option>
          <option value="GF Vanilla & Chocolate Marble [$25]">GF Vanilla & Chocolate Marble [$25]</option>
          <option value="GF White Chocolate [$25]">GF White Chocolate [$25]</option> 
          <option value="GF White Chocolate & Caramel Marble [$25]">GF White Chocolate & Caramel Marble [$25]</option>
          <option value="GF White Chocolate & Strawberry Marble [$25]">GF White Chocolate & Strawberry Marble [$25]</option> 
        </select>
      </div>
    `)
  }

  if ($('#cake_flavour_middle_tier').val() == 'Y') {
    cake_flavour_middle_tier = true  
    $('#custom-options').append(` 
      <div id="cake_flavour_middle_tier_option_container" class="product_option">
        <label for="cake_flavour_middle_tier_flavour">Please select your buttercake flavour - middle tier</label><br> 
        <select id="cake_flavour_middle_tier_flavour" name="cake_flavour_middle_tier_tier_flavour" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
          <option value="Caramel & Chocolate Marble">Caramel & Chocolate Marble</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="White Chocolate & Caramel">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry">White Chocolate & Strawberry Marble</option>
          <option value="Red Velvet">Red Velvet</option>
          <option value="Lemon">Lemon</option>
          <option value="GF Vanilla [$25]">GF Vanilla [$25]</option>
          <option value="GF Chocolate [$25]">GF Chocolate [$25]</option>
          <option value="GF Vanilla & Chocolate Marble [$25]">GF Vanilla & Chocolate Marble [$25]</option>
          <option value="GF White Chocolate [$25]">GF White Chocolate [$25]</option> 
          <option value="GF White Chocolate & Caramel Marble [$25]">GF White Chocolate & Caramel Marble [$25]</option>
          <option value="GF White Chocolate & Strawberry Marble [$25]">GF White Chocolate & Strawberry Marble [$25]</option> 
        </select>
      </div>
    `)
  } 

  if ($('#cake_flavour_bottom_tier').val() == 'Y') {
    cake_flavour_bottom_tier = true  
    $('#custom-options').append(` 
      <div id="cake_flavour_bottom_tier_option_container" class="product_option">
        <label for="cake_flavour_bottom_tier_flavour">Please select your buttercake flavour - bottom tier</label><br> 
        <select id="cake_flavour_bottom_tier_flavour" name="cake_flavour_bottom_tier_flavour" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
          <option value="Caramel & Chocolate Marble">Caramel & Chocolate Marble</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="White Chocolate & Caramel">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry">White Chocolate & Strawberry Marble</option>
          <option value="Red Velvet">Red Velvet</option>
          <option value="Lemon">Lemon</option>
          <option value="GF Vanilla [$25]">GF Vanilla [$25]</option>
          <option value="GF Chocolate [$25]">GF Chocolate [$25]</option>
          <option value="GF Vanilla & Chocolate Marble [$25]">GF Vanilla & Chocolate Marble [$25]</option>
          <option value="GF White Chocolate [$25]">GF White Chocolate [$25]</option> 
          <option value="GF White Chocolate & Caramel Marble [$25]">GF White Chocolate & Caramel Marble [$25]</option>
          <option value="GF White Chocolate & Strawberry Marble [$25]">GF White Chocolate & Strawberry Marble [$25]</option> 
        </select>
      </div>
    `)
  }
  
  if ($('#one_tier_cake_flavour').val() == 'Y') {
    one_tier_cake_flavour = true  
    $('#custom-options').append(` 
      <div id="one_tier_cake_flavour_option_container" class="product_option">
        <label for="one_tier_flavour">Please select your buttercake flavour</label><br> 
        <select id="one_tier_flavour" name="one_tier_flavour" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla & Chocolate Marble">Vanilla & Chocolate Marble</option>
          <option value="Caramel & Chocolate Marble">Caramel & Chocolate Marble</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="White Chocolate & Caramel">White Chocolate & Caramel Marble</option>
          <option value="White Chocolate & Strawberry">White Chocolate & Strawberry Marble</option>
          <option value="Red Velvet">Red Velvet</option>
          <option value="Lemon">Lemon</option>
          <option value="GF Vanilla [$25]">GF Vanilla [$25]</option>
          <option value="GF Chocolate [$25]">GF Chocolate [$25]</option>
          <option value="GF Vanilla & Chocolate Marble [$25]">GF Vanilla & Chocolate Marble [$25]</option>
          <option value="GF White Chocolate [$25]">GF White Chocolate [$25]</option> 
          <option value="GF White Chocolate & Caramel Marble [$25]">GF White Chocolate & Caramel Marble [$25]</option>
          <option value="GF White Chocolate & Strawberry Marble [$25]">GF White Chocolate & Strawberry Marble [$25]</option> 
        </select>
      </div>
    `)
  }

  if ($('#fondant_or_buttercream').val() == 'Y') {
    fondant_or_buttercream = true
    $('#custom-options').append(` 
      <div id="fondant_or_buttercream_option_container" class="product_option">
        <label for="fondant_or_buttercream_option">Would you like this to be made of Fondant or Buttercream?</label><br>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">
          Note: Please read the description to understand this further  
        </p>
        <select id="fondant_or_buttercream_option" name="fondant_or_buttercream_option" class="is-required">
          <option value="">Please select</option>
          <option value="Fondant [$40]">Fondant ($40)</option>
          <option value="Buttercream">Buttercream</option> 
        </select>
      </div>
    `)
  }

  if ($('#drip').val() == 'Y') {
    drip = true    
    $('#custom-options').append(` 
      <div id="drip_option_container" class="product_option">
        <label for="drip_option">Would you like a drip?</label><br> 
        <select id="drip_option" name="drip_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="drip_colour_option_container" class="product_option" style="display:none;">
        <label for="drip_colour_option">What colour drip would you like?</label><br> 
        <select id="drip_colour_option" name="drip_colour_option">
          <option value="">Please select</option>
          <option value="Chocolate">Chocolate</option>
          <option value="White Chocolate">White Chocolate</option>
          <option value="Colour [$10]">Colour ($10)</option>
          <option value="Gold Drips [$50]">Gold Drips ($50)</option>
        </select>
      </div>

      <div id="drip_colour_colour_option_container" class="product_option" style="display:none;">
        <label for="drip_colour_colour_option">Cake drip colour</label><br> 
        <input type="color" id="drip_colour_colour_option" name="drip_colour_colour_option" value="#ffffff">
      </div>

      <div id="drip_colour_golds_option_container" class="product_option" style="display:none;">
        <label for="drip_colour_golds_option">Please select your gold drip option</label><br> 
        <select id="drip_colour_golds_option" name="drip_colour_golds_option">
          <option value="">Please select</option>
          <option value="Gold">Gold</option>
          <option value="Rose Gold">Rose Gold</option>
          <option value="Silver">Silver</option>
        </select>
      </div> 
    `)

    $('#drip_option').on('change', function() { 
      $('#drip_colour_option_container').hide()  
      $('#drip_colour_colour_option_container').hide()
      $('#drip_colour_golds_option_container').hide()

      if (this.value == 'Yes, Please') {
        $('#drip_colour_option_container').show() 
      } else { 
        drip = false
      }
    }) 

    $('#drip_colour_option').on('change', function() { 
      $('#drip_colour_colour_option_container').hide()
      $('#drip_colour_golds_option_container').hide()

      if (this.value == 'Colour [$10]') {  
        $('#drip_colour_colour_option_container').show() 
      }

      if (this.value == 'Gold Drips [$50]') {   
        $('#drip_colour_golds_option_container').show() 
      }
    })
  }

  if ($('#macarons').val() == 'Y') {
    macarons = true    
    $('#custom-options').append(` 
      <div id="macarons_option_container" class="product_option">
        <label for="macarons_option">Would you like macarons?</label><br> 
        <select id="macarons_option" name="macarons_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="macarons_qty_option_container" class="product_option" style="display:none;">
        <label for="macarons_qty_option">How many macarons would you like?</label><br> 
        <select id="macarons_qty_option" name="macarons_qty_option">
          <option value="">Please select</option>
          <option value="3 [$12]">3 ($12)</option>
          <option value="5 [$20]">5 ($20)</option>
          <option value="8 [$30]">8 ($30)</option>
        </select>
      </div>

      <div id="macarons_colour_flavour_option_container" class="product_option" style="display:none;">
        <label for="macarons_colour_flavour_option">What colour/flavour?</label><br> 
        <select id="macarons_colour_flavour_option" name="macarons_colour_flavour_option">
          <option value="">Please select</option>
          <option value="White / Vanilla">White / Vanilla</option>
          <option value="Brown / Chocolate">Brown / Chocolate</option>
          <option value="Light Brown / Caramel">Light Brown / Caramel</option>
          <option value="Blue / Blueberry">Blue / Blueberry</option>
          <option value="Baby Blue / Vanilla Cupcake">Baby Blue / Vanilla Cupcake</option>
          <option value="Pink / Strawberry">Pink / Strawberry</option>
          <option value="Hot Pink / Passion Fruit">Hot Pink / Passion Fruit</option>
          <option value="Off White Dirty / Cookies & Cream">Off White Dirty / Cookies & Cream</option>
          <option value="Yellow / Mango">Yellow / Mango</option>
          <option value="Green / Pistachio">Green / Pistachio</option>
        </select>
      </div> 
    `)

    $('#macarons_option').on('change', function() { 
      $('#macarons_qty_option_container').hide() 
      $('#macarons_colour_flavour_option_container').hide() 

      if (this.value == 'Yes, Please') { 
        $('#macarons_qty_option_container').show() 
        $('#macarons_colour_flavour_option_container').show() 
      } else { 
        macarons = false
      }
    })
  }
  
  if ($('#disney_princess').val() == 'Y') {
    disney_princess = true
    $('#custom-options').append(`
      <div id="disney_princess_option_container" class="product_option">
        <label for="disney_princess_option">What princess or Barbie would you like?</label><br> 
        <select id="disney_princess_option" name="disney_princess_option" class="is-required">
          <option value="">Please select</option>
          <option value="Snow White (Snow White and the Seven Dwarves)">Snow White (Snow White and the Seven Dwarves)</option>
          <option value="Cinderella (Cinderella)">Cinderella (Cinderella)</option>
          <option value="Aurora (Sleeping Beauty)">Aurora (Sleeping Beauty)</option>
          <option value="Ariel (The Little Mermaid)">Ariel (The Little Mermaid)</option>
          <option value="Belle (Beauty and the Beast)">Belle (Beauty and the Beast)</option>
          <option value="Jasmine (Aladdin)">Jasmine (Aladdin)</option>
          <option value="Pocahontas (Pocahontas)">Pocahontas (Pocahontas)</option>
          <option value="Mulan (Mulan)">Mulan (Mulan)</option>
          <option value="Tiana (The Princess and the Frog)">Tiana (The Princess and the Frog)</option>
          <option value="Rapunzel (Tangled)">Rapunzel (Tangled)</option>
          <option value="Merida (Brave)"Merida (Brave)></option>
          <option value="Moana (Moana)">Moana (Moana)</option>
          <option value="Barbie">Barbie</option>
        </select>
      </div>
    `)
  }

  if ($('#character_name').val() == 'Y') {
    character_name = true
    $('#custom-options').append(`
      <div id="character_name_option_container" class="product_option">
        <label for="character_name_option">What character would you like?</label><br>
        <input type="text" name="character_name_option" id="character_name_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#minion_character').val() == 'Y') {
    minion_character = true
    $('#custom-options').append(`
      <div id="minion_character_option_container" class="product_option">
        <label for="minion_character_option">Minion character</label><br>
        <select id="minion_character_option" name="minion_character_option" class="is-required">
          <option value="">Please select</option>
          <option value="Kevin">Kevin</option>
          <option value="Stuart">Stuart</option>
          <option value="Bob">Bob</option>
          <option value="Dave">Dave</option>
          <option value="Jerry">Jerry</option>
          <option value="Phil">Phil</option>
          <option value="Carl">Carl</option>
          <option value="Tim">Tim</option>
        </select>
      </div>
    `)
  }

  if ($('#brand_of_choice').val() == 'Y') {
    brand_of_choice = true
    $('#custom-options').append(`
      <div id="brand_of_choice_option_container" class="product_option">
        <label for="brand_of_choice_option">Please mention here the brand of your choice</label><br>
        <input type="text" name="brand_of_choice_option" id="brand_of_choice_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#cake_team').val() == 'Y') {
    cake_team = true
    $('#custom-options').append(`
      <div id="cake_team_option_container" class="product_option">
        <label for="cake_team_option">Please mention here the team for your cake</label><br>
        <input type="text" name="cake_team_option" id="cake_team_option" style="width:100%;" class="is-required" maxlenght="20"> 
      </div>
    `)
  }

  if ($('#cupcakes_flavour').val() == 'Y') {
    cupcakes_flavour = true
    $('#custom-options').append(`
      <div id="cupcakes_flavour_option_container" class="product_option">
        <label for="cupcakes_flavour_option">Cupcakes flavour</label><br> 
        <select id="cupcakes_flavour_option" name="cupcakes_flavour_option" class="is-required">
          <option value="">Please select</option>
          <option value="Vanilla">Vanilla</option>
          <option value="Chocolate">Chocolate</option>
          <option value="Vanilla Gluten Free">Vanilla Gluten Free</option>
        </select>
      </div>
    `)
  }

  if ($('#cupcakes_text').val() == 'Y') {
    cupcakes_text = true
    $('#custom-options').append(`
      <div id="cupcakes_text_option_container" class="product_option">
        <label for="cupcakes_text_option">Please type the text for the cupcakes here</label><br>
        <input type="text" name="cupcakes_text_option" id="cupcakes_text_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#cross_or_name').val() == 'Y') {
    cross_or_name = true
    $('#custom-options').append(`
      <div id="cross_or_name_option_container" class="product_option">
        <label for="cross_or_name_option">Would you like a cross or name for the front in acrylic?</label><br> 
        <select id="cross_or_name_option" name="cross_or_name_option" class="is-required">
          <option value="">Please select</option>
          <option value="None">None</option>
          <option value="A Cross [$15]">A Cross ($15)</option>
          <option value="A Name [$20]">A Name ($20)</option>
        </select>
      </div>

      <div id="cross_or_name_colour_option_container" class="product_option" style="display:none;">
        <label for="cross_or_name_colour_option">What colour would you like?</label><br> 
        <select id="cross_or_name_colour_option" name="cross_or_name_colour_option">
          <option value="">Please select</option>
          <option value="Gold Mirror">Gold Mirror</option>
          <option value="Gold Glitter">Gold Glitter</option>
          <option value="Silver Mirror">Silver Mirror</option>
          <option value="Silver Glitter">Silver Glitter</option>
          <option value="Rose Gold Mirror">Rose Gold Mirror</option>
          <option value="Black Matte">Black Matte</option>
          <option value="Wooden">Wooden</option>
        </select>
      </div>

      <div id="cross_or_name_text_option_container" class="product_option" style="display:none;">
        <label for="cross_or_name_text_option">Please type the name here</label><br>
        <input type="text" name="cross_or_name_text_option" id="cross_or_name_text_option" style="width:100%;"> 
      </div>
    `)
    
    $('#cross_or_name_option').on('change', function() { 
      $('#cross_or_name_colour_option_container').hide()
      $('#cross_or_name_text_option_container').hide()
      
      if (this.value.lenght && this.value != 'None') {  
        $('#cross_or_name_colour_option_container').show()
      }

      if (this.value == 'A Name [$20]') {
        $('#cross_or_name_text_option_container').show()
      }
    })
  }

  if ($('#chocolate_happy_birthday_plaque').val() == 'Y') {
    chocolate_happy_birthday_plaque = true
    $('#custom-options').append(`
      <div id="chocolate_happy_birthday_plaque_option_container" class="product_option">
        <label for="chocolate_happy_birthday_plaque_option">Would you like a chocolate happy birthday plaque?</label><br> 
        <select id="chocolate_happy_birthday_plaque_option" name="chocolate_happy_birthday_plaque_option" class="is-required">
          <option value="">Please select</option>
          <option value="No, Thank You">No, Thank You</option>
          <option value="Yes, Please [$8]">Yes, Please ($8)</option>
        </select>
      </div>
    `)
  }

  if ($('#cake_drink_inspiration').val() == 'Y') {
    cake_drink_inspiration = true
    $('#custom-options').append(`
      <div id="cake_drink_inspiration_option_container" class="product_option">
        <label for="cake_drink_inspiration_option">What drink would you like this cake to be inspired on?</label><br>
        <input type="text" name="cake_drink_inspiration_option" id="cake_drink_inspiration_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#front_plaque_text').val() == 'Y') {
    front_plaque_text = true
    $('#custom-options').append(`
      <div id="front_plaque_text_option_container" class="product_option">
        <label for="front_plaque_text_option">Please write here the text on the front plaque</label><br>
        <input type="text" name="front_plaque_text_option" id="front_plaque_text_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#colour').val() == 'Y') {
    colour = true
    $('#custom-options').append(`
      <div id="colour_option_container" class="product_option">
        <label for="colour_option">Colour</label><br>
        <input type="color" name="colour_option" id="colour_option" class="is-required" value="#ffffff"> 
      </div>
    `)
  }

  if ($('#cupcake_theme_colour').val() == 'Y') {
    cupcake_theme_colour = true
    $('#custom-options').append(`
      <div id="cupcake_theme_colour_option_container" class="product_option">
        <label for="cupcake_theme_colour_option">Please select the main colour of your cupcake theme</label><br>
        <input type="color" name="cupcake_theme_colour_option" id="cupcake_theme_colour_option" class="is-required" value="#ffffff"> 
      </div>
    `)
  }

  if ($('#hb_round_acrylic_toppers').val() == 'Y') {
    hb_round_acrylic_toppers = true
    $('#custom-options').append(`
      <div id="hb_round_acrylic_toppers_option_container" class="product_option">
        <label for="hb_round_acrylic_toppers_option">Would you like to add HB round acrylic toppers?</label><br> 
        <select id="hb_round_acrylic_toppers_option" name="hb_round_acrylic_toppers_option" class="is-required">
          <option value="">Please select</option>
          <option value="None">None</option>
          <option value="6 [$35]">6 ($35)</option>
          <option value="12 [$66]">12 ($66)</option>
          <option value="24 [$128]">24 ($128)</option>
          <option value="50 [$250]">50 ($250)</option>
        </select>
      </div>
    `) 
  }

  if ($('#cashews').val() == 'Y') {
    cashews = true
    $('#custom-options').append(`
      <div id="cashews_option_container" class="product_option">
        <label for="cashews_option">Would you like to add sprinkles?</label><br> 
        <select id="cashews_option" name="cashews_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>
    `) 
  }
    
  if ($('#glitter').val() == 'Y') {
    glitter = true
    $('#custom-options').append(`
      <div id="glitter_option_container" class="product_option">
        <label for="glitter_option">Would you like to add glitter?</label><br> 
        <select id="glitter_option" name="glitter_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>
    `) 
  }

  if ($('#gold_leaf').val() == 'Y') {
    gold_leaf = true
    $('#custom-options').append(`
      <div id="gold_leaf_option_container" class="product_option">
        <label for="gold_leaf_option">Would you like to add gold leaf?</label><br> 
        <select id="gold_leaf_option" name="gold_leaf_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>
    `) 
  }
  
  if ($('#colour_swirl').val() == 'Y') {
    colour_swirl = true
    $('#custom-options').append(`
      <div id="colour_swirl_option_container" class="product_option">
        <label for="colour_swirl_option">Please select your colour swirl</label>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">
          Note: Please be aware that variations in colour might apply, we always try to match the colour as close as possible to your selected one
        </p>
        <input type="color" name="colour_swirl_option" id="colour_swirl_option" class="is-required" value="#ffffff"> 
      </div> 
    `) 
  }
  
  if ($('#cannoli_fillings').val() == 'Y') {
    cannoli_fillings = true
    $('#custom-options').append(`
      <div id="cannoli_fillings_option_container" class="product_option">
        <label for="cannoli_fillings_option">Please select your fillings</label><br> 
        <select id="cannoli_fillings_option" name="cannoli_fillings_option" class="is-required">
          <option value="">Please select</option>
          <option value="All Vanilla Custard">All Vanilla Custard</option>
          <option value="All Chocolate Custard">All Chocolate Custard</option>
          <option value="All Nutella Custard">All Nutella Custard</option>
          <option value="All Biscoff Custard">All Biscoff Custard</option>
          <option value="Citrus Custard">Citrus Custard</option>
          <option value="Vanilla & Chocolate Custard">Vanilla & Chocolate Custard</option>
          <option value="Vanilla & Nutella Custard">Vanilla & Nutella Custard</option>
          <option value="Vanilla & Biscoff Custard">Vanilla & Biscoff Custard</option>
          <option value="Vanilla & Citrus Custard">Vanilla & Citrus Custard</option>
          <option value="Chocolate & Nutella Custard">Chocolate & Nutella Custard</option>
          <option value="Chocolate & Biscoff Custard">Chocolate & Biscoff Custard</option>
          <option value="Nutella & Biscoff Custard">Nutella & Biscoff Custard</option>
        </select>
      </div> 
    `) 
  }

  if ($('#cannoli_colours').val() == 'Y') {
    cannoli_colours = true
    $('#custom-options').append(`
      <div id="cannoli_colours_option_container" class="product_option">
        <label for="cannoli_colours_option">What colour would you like?</label><br> 
        <select id="cannoli_colours_option" name="cannoli_colours_option" class="is-required">
          <option value="">Please select</option>
          <option value="Pastel Colours">Pastel Colours</option>
          <option value="Bright Colours">Bright Colours</option>
          <option value="Chocolate Coated (With Strawberries)">Chocolate Coated (With Strawberries)</option>
        </select>
      </div> 

      <div id="cannoli_pastel_colours_option_container" class="product_option" style="display:none;">
        <label for="cannoli_pastel_colours_option">Please select one</label><br> 
        <select id="cannoli_pastel_colours_option" name="cannoli_pastel_colours_option">
          <option value="">Please select</option>
          <option value="White">White</option>
          <option value="Pink">Pink</option>
          <option value="Purple">Purple</option>
          <option value="Blue">Blue</option>
          <option value="Green">Green</option>
          <option value="Yellow">Yellow</option>
          <option value="Orange">Orange</option>
        </select>
      </div>

      <div id="cannoli_bright_colours_option_container" class="product_option" style="display:none;">
        <label for="cannoli_bright_colours_option">Please select one</label><br> 
        <select id="cannoli_bright_colours_option" name="cannoli_bright_colours_option">
          <option value="">Please select</option>
          <option value="Pink">Pink</option>
          <option value="Yellow">Yellow</option>
          <option value="Orange">Orange</option>
        </select>
      </div>

      <div id="cannoli_dark_colours_option_container" class="product_option" style="display:none;">
        <label for="cannoli_dark_colours_option">Please select one</label><br> 
        <select id="cannoli_dark_colours_option" name="cannoli_dark_colours_option">
          <option value="">Please select</option>
          <option value="Blue">Blue</option>
          <option value="Purple">Purple</option>
          <option value="Red">Red</option>
          <option value="Black (done out of dark chocolate)">Black (done out of dark chocolate)</option>
        </select>
      </div>
    `)

    $('#cannoli_colours_option').on('change', function() {   
      $('#cannoli_pastel_colours_option_container').hide()
      $('#cannoli_bright_colours_option_container').hide()
      $('#cannoli_dark_colours_option_container').hide()
      $('#cannoli_flowers_option_container').show()

      if (this.value == 'Pastel Colours') {
        $('#cannoli_pastel_colours_option_container').show()
      }

      if (this.value == 'Bright Colours') {
        $('#cannoli_bright_colours_option_container').show()
      }

      if (this.value == 'Dark Colours') {
        $('#cannoli_dark_colours_option_container').show()
      }

      if (this.value == 'Chocolate Coated (With Strawberries)') {
        $('#cannoli_flowers_option_container').hide()
      }
    })
  }

  if ($('#cannoli_flowers').val() == 'Y') {
    cannoli_flowers = true 
    $('#custom-options').append(`
      <div id="cannoli_flowers_option_container" class="product_option">
        <label for="cannoli_flowers_option">Would you like flowers?</label><br> 
        <select id="cannoli_flowers_option" name="cannoli_flowers_option">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div> 
    `) 
  }

  if ($('#customised_mini_acrylic_name').val() == 'Y') {
    customised_mini_acrylic_name = true 
    $('#custom-options').append(`
      <div id="customised_mini_acrylic_name_option_container" class="product_option">
        <label for="customised_mini_acrylic_name_option">Would you like a customised mini acrylic name?</label><br> 
        <select id="customised_mini_acrylic_name_option" name="customised_mini_acrylic_name_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$15]">Yes, Please ($15)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>

      <div id="customised_mini_acrylic_name_colour_option_container" class="product_option" style="display:none;">
        <label for="customised_mini_acrylic_name_colour_option">Please select your colour</label><br> 
        <select id="customised_mini_acrylic_name_colour_option" name="customised_mini_acrylic_name_colour_option">
          <option value="">Please select</option>
          <option value="Gold Mirror">Gold Mirror</option>
          <option value="Gold Glitter">Gold Glitter</option>
          <option value="Silver Mirror">Silver Mirror</option>
          <option value="Silver Glitter">Silver Glitter</option>
          <option value="Rose Gold Mirror">Rose Gold Mirror</option>
          <option value="Black Matte">Black Matte</option>
          <option value="Wooden">Wooden</option> 
        </select>
      </div>

      <div id="customised_mini_acrylic_name_text_option_container" class="product_option" style="display:none;"> 
        <label for="customised_mini_acrylic_name_text_option">Mini acrylic name to read</label><br>
        <input type="text" name="customised_mini_acrylic_name_text_option" id="customised_mini_acrylic_name_text_option" style="width:100%;"> 
      </div>
    `)

    $('#customised_mini_acrylic_name_option').on('change', function() {   
      $('#customised_mini_acrylic_name_colour_option_container').hide()
      $('#customised_mini_acrylic_name_text_option_container').hide()

      if (this.value == 'Yes, Please [$15]') { 
        $('#customised_mini_acrylic_name_colour_option_container').show()
        $('#customised_mini_acrylic_name_text_option_container').show()
      }
    })
  }

  if ($('#cross').val() == 'Y') {
    cross = true
    $('#custom-options').append(`
      <div id="cross_option_container" class="product_option">
        <label for="cross_option">Would you like a cross?</label><br> 
        <select id="cross_option" name="cross_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>
    `)
  }

  if ($('#reference_picture').val() == 'Y') {
    reference_picture = true
    $('#custom-options').append(`
      <div id="reference_picture_option_container" class="product_option">
        <label for="reference_picture_option">Please upload here a reference picture</label><br>
        <input type="file" name="reference_picture_option" id="reference_picture_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#photo_upload').val() == 'Y') {
    photo_upload = true
    $('#custom-options').append(`
      <div id="photo_upload_option_container" class="product_option"> 
        <label for="photo_upload_option">Please upload your photo here</label>
        <p style="font-size:12px;text-transform:uppercase;font-weight:bold;">Note: Please be aware that we are not computer designers, so your image have to be uploaded ready to print and in a round shape, if we need to make it round, we are not responsable of damaging the look of the image uploaded.</p>
        <input type="file" name="photo_upload_option" id="photo_upload_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#picture_upload').val() == 'Y') {
    picture_upload = true
    $('#custom-options').append(`
      <div id="picture_upload_option_container" class="product_option"> 
        <label for="picture_upload_option">Please upload your picture here</label><br>
        <input type="file" name="picture_upload_option" id="picture_upload_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#image_on_top').val() == 'Y') {
    image_on_top = true 
    $('#custom-options').append(`
      <div id="image_on_top_option_container" class="product_option">
        <label for="image_on_top_option">Would you like an image on top of the cake?</label><br> 
        <select id="image_on_top_option" name="image_on_top_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$30]">Yes, Please ($30)</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>
     
      <div id="image_on_top_image_option_container" class="product_option" style="display:none;">
        <label for="image_on_top_image_option">Please upload your picture here</label><br> 
        <p>
          NOTE: Please upload an image in the same shape as your cake selection 😊
          For example: Round cakes require round images — As if you upload square or rectangle images 
          and you selected a round cake, will be automatically cropped by the system when printed and 
          part of the images will be cropped.
        </p>
        <input type="file" name="image_on_top_image_option" id="image_on_top_image_option" style="width:100%;"> 
      </div>
    `) 

    $('#image_on_top_option').on('change', function() { 
      $('#image_on_top_image_option_container').hide()
      
      if (this.value == 'Yes, Please [$30]') {   
        $('#image_on_top_image_option_container').show()
      }
    })
  }

  if ($('#cake_image').val() == 'Y') {
    cake_image = true
    $('#custom-options').append(` 
      <div id="cake_image_option_container" class="product_option">
        <label for="cake_image_option">Please upload your image here</label><br>
        <p style="font-size:14px;margin-bottom:10px;">  
          NOTE: Please make sure to upload the imagine in the same shape for the cake you selected, as we dont modify images, we print straigh what you send.
        </p>
        <input type="file" name="cake_image_option" id="cake_image_option" style="width:100%;" class="is-required"> 
      </div>
    `)
  } 
  
  if ($('#name').val() == 'Y') {
    name = true
    $('#custom-options').append(`
      <div id="name_option_container" class="product_option">
        <label for="name">Please type the name to be added to the cake</label><br>
        <input type="text" name="name" id="name" style="width:100%;" class="is-required"> 
      </div>
    `)
  }

  if ($('#age').val() == 'Y') {
    age = true
    $('#custom-options').append(` 
      <div id="age_option_container" class="product_option">
        <label for="age">Please add the age for the cake</label><br> 
        <input type="text" name="age" id="age" style="width:100%;" class="is-required">   
      </div>
    `)
  }

  if ($('#flowers').val() == 'Y') {
    flowers = true
    $('#custom-options').append(` 
      <div id="flowers_option_container" class="product_option"> 
        <label for="flowers_option">Would you like flowers?</label>
        <p style="font-size:14px;margin-bottom:5px;">    
          Note: We use Fresh flowers most of the times, however, if there is no availability of a certain colour, we will use fake flowers 
          (Not from the $2 shop, this fake flowers are actually more expensive than fresh ones)
        </p> 
        <select id="flowers_option" name="flowers_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option>
        </select>
      </div>

      <div id="flowers_size_option_container" class="product_option" style="display:none;"> 
        <label for="flowers_size_option">Please select the size bouquet flower needed?</label>
        <select id="flowers_size_option" name="flowers_size_option">
          <option value="">Please select</option>
          <option value="Small [$50]">Small ($50)</option>
          <option value="Medium [$80]">Medium ($80)</option>
          <option value="Large [$110]">Large ($110)</option>
        </select>
      </div>

      <div id="flowers_colour_theme_option_container" class="product_option" style="display:none;"> 
        <label for="flowers_colour_theme_option">Please type the colour themed you want for the flowers</label>
        <p style="font-size:14px;margin-bottom:10px;">  
          Note: DO NOT type specific flowers, as we work with whats available colour wise, if you need an specific flower request, please email us prior placing your order
        </p>
        <input type="text" name="flowers_colour_theme_option" id="flowers_colour_theme_option" style="width:100%;">  
      </div>
      
      <div id="flowers_arrangement_option_container" class="product_option" style="display:none;"> 
        <label for="flowers_arrangement_option">How would you like your flowers arranged?</label>
        <select id="flowers_arrangement_option" name="flowers_arrangement_option">
          <option value="">Please select</option>
          <option value="As per discretion of the cake decorator">As per discretion of the cake decorator</option>
          <option value="My own way">My own way</option>
        </select>
      </div>
      
      <div id="flowers_own_arrangement_option_container" class="product_option" style="display:none;"> 
        <label for="flowers_own_arrangement_option">Please explain the arrangement look for your flowers</label>
        <input type="text" name="flowers_own_arrangement_option" id="flowers_own_arrangement_option" style="width:100%;">  
      </div>
    `)

    $('#flowers_option').on('change', function() { 
      $('#flowers_size_option_container').hide()
      $('#flowers_colour_theme_option_container').hide()
      $('#flowers_arrangement_option_container').hide()
      
      if (this.value == 'Yes, Please') {  
        $('#flowers_size_option_container').show()
        $('#flowers_colour_theme_option_container').show() 
        $('#flowers_arrangement_option_container').show()
      } else { 
        flowers = false
      }
    })

    $('#flowers_arrangement_option').on('change', function() { 
      $('#flowers_own_arrangement_option_container').hide() 
      
      if (this.value == 'My own way') {  
        $('#flowers_own_arrangement_option_container').show()
      }
    })
  } 

  if ($('#colour_swap').val() == 'Y') {
    colour_swap = true
    $('#custom-options').append(` 
      <div id="colour_swap_container" class="product_option">
        <label for="colour_swap">Please mention here if you wish a colour swap</label><br>
        <input type="text" name="colour_swap" id="colour_swap" style="width:100%;" class="is-required">
        <p style="font-size:14px;margin-top:5px;">Note: Adding golds is not acceptable, please contact us prior if you need to swap a colour for gold.</p>  
      </div>
    `)
  }
  
  if ($('#cake_topper').val() == 'Y') {    
    cakeTopper()
  }

  if ($('#text_on_board').val() == 'Y') { 
    $('#custom-options').append(`
      <div id="text_on_board_option_container" class="product_option">
        <label for="text_on_board_yes_no">Would you like to add text on the board?</label><br> 
        <select id="text_on_board_yes_no" name="text_on_board_yes_no" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="text_on_board_chocolate_or_colour_container" class="product_option text-on-board-customization" style="display:none;">
        <label for="text_on_board_chocolate_colour">Please select between colour or golds</label><br> 
        <select id="text_on_board_chocolate_colour" name="text_on_board_chocolate_colour">
          <option value="">Please select</option>
          <option value="Colour [$10]">Colour ($10)</option> 
          <option value="Golds [$20]">Golds ($20)</option> 
        </select>
      </div> 

      <div id="text_on_board_colour_container" class="product_option text-on-board-customization" style="display:none;">  
        <label for="text_on_board_colour">Colour</label><br> 
        <input type="color" id="text_on_board_colour" name="text_on_board_colour" value="#ffffff">
      </div>

      <div id="text_on_board_gold_colours_container" class="product_option text-on-board-customization" style="display:none;">
        <label for="text_on_board_gold_colours">Please select the colour</label><br> 
        <select id="text_on_board_gold_colours" name="text_on_board_gold_colours">
          <option value="">Please select</option>
          <option value="Gold">Gold</option>
          <option value="Silver">Silver</option> 
          <option value="Rose Gold">Rose Gold</option> 
        </select> 
      </div>

      <div id="text_on_board_text_container" class="product_option text-on-board-customization" style="display:none;"> 
        <label for="text_on_board_text">Please add your text bellow</label><br> 
        <input type="text" id="text_on_board_text" name="text_on_board_text" style="width:100%;"> 
      </div> 
    `)

    $('#text_on_board_yes_no').on('change', function() { 
      $('.text-on-board-customization').hide()
      text_on_board = false
      if (this.value == 'Yes, Please') {
        text_on_board = true
        $('#text_on_board_chocolate_or_colour_container').show()
        $('#text_on_board_text_container').show() 
      } else if (this.value == 'No, Thank You') {
        text_on_board = false
        $('.text-on-board-customization').hide() 
      }
    })

    $('#text_on_board_chocolate_colour').on('change', function() { 
      $('#text_on_board_colour_container').hide()
      $('#text_on_board_gold_colours_container').hide() 
      
      if (this.value == 'Colour [$10]') {
        $('#text_on_board_colour_container').show()
      } else if (this.value == 'Golds [$20]') {
        $('#text_on_board_gold_colours_container').show()
      }
    })
  }
  
  if ($('#letter_number_cake_flowers').val() == 'Y') {
    var letter_number_cake_flowers = true
    $('#custom-options').append(`
      <div id="letter_number_cake_flowers_option_container" class="product_option">
        <label for="letter_number_cake_flowers_option">Would you like flowers?</label><br> 
        <select id="letter_number_cake_flowers_option" name="letter_number_cake_flowers_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please [$15]">Yes, Please ($15)</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>
    `)
  }

  if ($('#mini_alcohol_bottles').val() == 'Y') {
    var mini_alcohol_bottles = true
    $('#custom-options').append(`
      <div id="mini_alcohol_bottles_option_container" class="product_option">
        <label for="mini_alcohol_bottles_option">Would you like mini alcohol bottles?</label><br> 
        <select id="mini_alcohol_bottles_option" name="mini_alcohol_bottles_option" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="mini_alcohol_bottles_qty_option_container" class="product_option" style="display:none;">
        <p style="font-size:14px;"> 
          NOTE: When choosing this option you will be able to choose the quantity but NOT the alcohol brand. We will use whatever mini alcohol is available at the time to match the colour/theme perfectly. If you wish to have a specific alcohol brand please contact ricky@polespatisserie.com.au and he will advise you what to do best.
        </p> 
        <label for="mini_alcohol_bottles_qty_option">How many mini bottles would you like?</label><br> 
        <select id="mini_alcohol_bottles_qty_option" name="mini_alcohol_bottles_qty_option">
          <option value="">Please select</option>
          <option value="1 [$15]">1 ($15)</option>
          <option value="2 [$25]">2 ($25)</option>
          <option value="3 [$35]">3 ($35)</option>
        </select>
      </div>
    `)

    $('#mini_alcohol_bottles_option').on('change', function() { 
      $('#mini_alcohol_bottles_qty_option_container').hide()

      if (this.value == 'Yes, Please') {
        $('#mini_alcohol_bottles_qty_option_container').show() 
      } else {
        mini_alcohol_bottles = false
      }
    })
  }

  if ($('#text_on_board_no_gold').val() == 'Y') { 
    $('#custom-options').append(`
      <div id="text_on_board_option_container" class="product_option">
        <label for="text_on_board_yes_no">Would you like to add text on the board?</label><br> 
        <select id="text_on_board_yes_no" name="text_on_board_yes_no" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option>
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="text_on_board_chocolate_or_colour_container" class="product_option text-on-board-customization" style="display:none;">
        <label for="text_on_board_chocolate_colour">Please select colour</label><br> 
        <select id="text_on_board_chocolate_colour" name="text_on_board_chocolate_colour">
          <option value="">Please select</option>
          <option value="Colour [$10]">Colour ($10)</option> 
        </select>
      </div> 

      <div id="text_on_board_colour_container" class="product_option text-on-board-customization" style="display:none;">  
        <label for="text_on_board_colour">Colour</label><br> 
        <input type="color" id="text_on_board_colour" name="text_on_board_colour" value="#ffffff">
      </div>

      <div id="text_on_board_text_container" class="product_option text-on-board-customization" style="display:none;"> 
        <label for="text_on_board_text">Please add your text bellow</label><br> 
        <input type="text" id="text_on_board_text" name="text_on_board_text" style="width:100%;"> 
      </div> 
    `)

    $('#text_on_board_yes_no').on('change', function() { 
      $('.text-on-board-customization').hide()
      text_on_board = false
      if (this.value == 'Yes, Please') {
        text_on_board = true
        $('#text_on_board_chocolate_or_colour_container').show()
        $('#text_on_board_text_container').show() 
      } else if (this.value == 'No, Thank You') {
        text_on_board = false
        $('.text-on-board-customization').hide() 
      }
    })

    $('#text_on_board_chocolate_colour').on('change', function() { 
      $('#text_on_board_colour_container').hide() 
      
      if (this.value == 'Colour [$10]') {
        $('#text_on_board_colour_container').show()
      }
    })
  }
  
  if ($('#candles').val() == 'Y') { 
    candles = true
    $('#custom-options').append(`
      <div id="candles_option_container" class="product_option">
        <label for="candles">Would you like to add candles?</label><br>
        <select id="candles" name="candles" class="is-required">
          <option value="">Please select</option>
          <option value="Yes, Please">Yes, Please</option> 
          <option value="No, Thank You">No, Thank You</option> 
        </select>
      </div>

      <div id="candles_colours_option_container" class="product_option" style="display:none;">
        <label>Please select the colour of your candles</label>
        <table>
          <tr>
            <td style="font-weight:bold;"> 
              White 12 Pack ($10)
            </td>
            <td>
              <input type="number" id="candles_white" name="candles_white" style="width:75px;">  
            </td>
          </tr> 
          <tr>
            <td style="font-weight:bold;"> 
              Silver 12 Pack ($10)
            </td>
            <td>
              <input type="number" id="candles_silver" name="candles_silver" style="width:75px;">  
            </td>
          </tr>
          <tr>
            <td style="font-weight:bold;"> 
              Gold 12 Pack ($10)
            </td>
            <td>
              <input type="number" id="candles_gold" name="candles_gold" style="width:75px;"> 
            </td>
          </tr>
          <tr>
            <td style="font-weight:bold;">
              Rose Gold 12 Pack ($10)
            </td>
            <td>
              <input type="number" id="candles_rose_gold" name="candles_rose_gold" style="width:75px;">
            </td>
          </tr>
          <tr>
            <td style="font-weight:bold;">
              Black 12 Pack ($10) 
            </td> 
            <td>
              <input type="number" id="candles_black" name="candles_black" style="width:75px;">   
            </td>
          </tr>
          <tr>
        </table>
      </div> 
    `) 

    $('#candles').on('change', function() { 
      $('#candles_colours_option_container').hide() 
      if (this.value == 'Yes, Please') {
        $('#candles_colours_option_container').show()
      } else if (this.value == 'No, Thank You') {
        $('#candles_colours_option_container').hide()  
      }
    })
  }

  $('.product-form__cart-submit').hide()  

  $('.product-form__cart-submit').before(`
    <button type="button" class="btn" id="custom-add-to-cart">ADD TO CART</button>  
  `) 
  
  var productProperties = {}
  var customization_total = 0
  var variants = JSON.parse($('#product_variants').val()) 

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
        if ((encoded.length % 4) > 0) {
          encoded += '='.repeat(4 - (encoded.length % 4));
        }
        resolve(encoded);
      };
      reader.onerror = error => reject(error);
    });
  } 
  
  async function saveOrder() {
    customization_total = 0 
    
    $('#custom-options-validation').hide()

    if ($('#preparation_days').val() != 'N') {
      $('#custom-options').append(`<input type="hidden" name="properties[_preparation_days]" value='${$('#preparation_days').val()}'>`)    
    }

    if (how_many_letters_or_numbers == true) { 
      var selection = $('#how_many_letters_or_numbers_option').val() 
      
      productProperties['How many letters or numbers would you like?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[How many letters or numbers would you like?]" value="${selection}">`)

      var first_letter_or_number = $('#letter_number_one_option').val() 
      
      productProperties['Please select your first letter/number'] = first_letter_or_number
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your first letter/number/symbol]" value="${first_letter_or_number}">`)

      if (selection == 'Two [$90]') {
        var second_letter_or_number = $('#letter_number_two_option').val() 
        
        productProperties['Please select your second letter/number'] = second_letter_or_number
        $('#custom-options').append(`<input type="hidden" name="properties[Please select your second letter/number/symbol]" value="${second_letter_or_number}">`)
        
        customization_total += 90
      }
    }

    if (macarons_flavour == true) {   
      var flavour = $('#macarons_flavour_option').val() 
      productProperties['Flavour (colour) macarons'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Flavour (colour) macarons]" value="${flavour}">`)
    }
    
    if (letter_number_cake_flavour == true) { 
      var flavour = $('#letter_number_cake_flavour_option').val() 
      productProperties['Please select the base for your cake'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the base for your cake]" value="${flavour}">`) 
    }

    if (letter_number_cake_filling == true) { 
      var filling = $('#letter_number_cake_filling_option').val() 
      productProperties['Please select your filling'] = filling
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your filling]" value="${filling}">`)
    }

    if (letter_number_cake_flowers == true) {  
      var selection = $('#letter_number_cake_flowers_option').val() 
      productProperties['Would you like flowers?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like flowers?]" value="${selection}">`)
    
      if (selection == 'Yes, Please [$15]') {
        customization_total += 15
      }
    }

    if (gender_reveal_cupcake == true) { 
      var selection = $('#gender_reveal_cupcake_option').val() 
      
      productProperties['Would you like colour filling for a gender reveal?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like colour filling for a gender reveal?]" value="${selection}">`)

      if (selection == 'Yes, Please [$15]') {
        var selected_colour = $('#gender_reveal_cupcake_colour_option').val() 
        
        productProperties['What colour would you like?'] = selected_colour
        $('#custom-options').append(`<input type="hidden" name="properties[What colour would you like?]" value="${selected_colour}">`)
        
        customization_total += 15
      }
    } 

    if (gender_reveal_cake == true) { 
      var selection = $('#gender_reveal_cake_option').val() 
      
      productProperties['Would you like colour filling for a gender reveal?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like colour filling for a gender reveal?]" value="${selection}">`)

      if (selection == 'Yes, Please [$30]') {
        var selected_colour = $('#gender_reveal_cake_colour_option').val() 
        
        productProperties['What colour would you like?'] = selected_colour
        $('#custom-options').append(`<input type="hidden" name="properties[What colour would you like?]" value="${selected_colour}">`)
        
        customization_total += 15
      }
    }

    if (mini_alcohol_bottles == true) {  
      productProperties['Would you like mini alcohol bottles?'] = $('#mini_alcohol_bottles_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like mini alcohol bottles?]" value="${$('#mini_alcohol_bottles_option').val()}">`)
  
      if ($('#mini_alcohol_bottles_option').val() == 'Yes, Please') {
        var selection = $('#mini_alcohol_bottles_qty_option').val()
        productProperties['How many mini bottles would you like?'] = selection
        $('#custom-options').append(`<input type="hidden" name="properties[How many mini bottles would you like?]" value="${selection}">`)

        if (selection.includes('[')) {
          customization_total += parseInt(selection.substring(selection.indexOf("$") + 1, selection.lastIndexOf("]")))
        } 
      }
    }

    if (customised_round_edible_image == true) {
      var selection = $('#customised_round_edible_image_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please upload your photo here ]" value="${selection}">`)

      if (selection == 'Yes, Please [$10]') {
        customization_total += 10

        var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
        var fileInput = $('#customised_round_edible_image_image_option').prop('files')
        var attachmentObject = false
        var uploadError = false

        var file_data = $('#customised_round_edible_image_image_option').prop('files')[0];   
        var form_data = new FormData();                  
        form_data.append('fileInput', file_data); 
        
        if (fileInput.length > 0) {
          await $.ajax({
            url: 'https://custom.fizdigital.online/polesImageUpload.php',
            method: 'POST',
            data: form_data,   
            processData: false,
            contentType: false, 
            success: function (response) {
              var image_url = 'https://custom.fizdigital.online/' + response
              $('#custom-options').append(`<input type="hidden" name="properties[Please upload your image here]" value="${image_url}">`) 
            }, 
          });
        }
      }
    }

    if (letter_number_cake_customised_mini_acrylic_name == true) {
      var selection = $('#letter_number_cake_customised_mini_acrylic_name_option').val()
      productProperties['Would you like a customised mini acrylic name?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a customised mini acrylic name?]" value="${selection}">`)
  
      if (selection == 'Yes, Please [$15]') { 
        productProperties['Mini acrylic name to read'] = $('#customised_mini_acrylic_name_text_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Mini acrylic name to read]" value="${$('#customised_mini_acrylic_name_text_option').val()}">`)

        customization_total += 15
      } 
    } 

    if (letter_number_cake_theme == true) {  
      var theme = $('#letter_number_cake_theme_option').val() 
      productProperties['Please explain your theme'] = theme
      $('#custom-options').append(`<input type="hidden" name="properties[Please explain your theme]" value="${theme}">`)
    }
    
    if (cake_flavour_milkshake == true) {
      var flavour = $('#cake_flavour_milkshake_option').val() 
      productProperties['Please select your buttercake flavour'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour]" value="${flavour}">`)
    }

    if (buttercream_colour_milkshake == true) {
      var colour = $('#buttercream_colour_milkshake_option').val() 
      productProperties['Please select the outside buttercream colour'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the outside buttercream colour]" value="${colour}">`)
    } 

    if (teacake_flavour == true) { 
      var flavour = $('#teacake_flavour_option').val() 
      productProperties['What flavour teacake would you like?'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[What flavour teacake would you like?]" value="${flavour}">`)
    }
      
    if (cake_flavour == true) {
      var flavour = $('#cake_flavour_flavour').val() 
      productProperties['Please select your buttercake flavour'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour]" value="${flavour}">`)

      if (flavour.includes('[')) {  
        customization_total += parseInt(flavour.substring(flavour.indexOf("$") + 1, flavour.lastIndexOf("]")))
      } 
    }

    if (harry_potter_house == true) {  
      var selection = $('#harry_potter_house_option').val()  
      productProperties['What Harry Potter house would you like?'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[What Harry Potter house would you like?]" value="${selection}">`)
    }

    if (dory_or_nemo == true) {  
      var selection = $('#dory_or_nemo_option').val()  
      productProperties['Dory or Nemo?'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Dory or Nemo?]" value="${selection}">`)
    }
      
    if (custom_image_cake_flavour == true) {
      var flavour = $('#custom_image_cake_flavour_option').val() 
      productProperties['Please select your buttercake flavour'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour]" value="${flavour}">`)
    }

    if (custom_image_cake_inside == true) {
      var side_look = $('#custom_image_cake_inside_option').val() 
      productProperties[' Please select the look on the side of the cake'] = side_look
      $('#custom-options').append(`<input type="hidden" name="properties[ Please select the look on the side of the cake]" value="${side_look}">`)
    }  

    if (one_tier_cake_flavour == true) {
      var flavour = $('#one_tier_flavour').val()
      productProperties['Please select your buttercake flavour'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour]" value="${flavour}">`)

      if (flavour.includes('[')) {
        customization_total += parseInt(flavour.substring(flavour.indexOf("$") + 1, flavour.lastIndexOf("]")))
      } 
    }

    if (cake_flavour_top_tier == true) {
      var flavour = $('#cake_flavour_top_tier_flavour').val()
      productProperties['Please select your buttercake flavour - top tier'] = flavour 
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour - top tier]" value="${flavour}">`)

      if (flavour.includes('[')) {
        customization_total += parseInt(flavour.substring(flavour.indexOf("$") + 1, flavour.lastIndexOf("]")))
      } 
    }

    if (cake_flavour_middle_tier == true) {
      var flavour = $('#cake_flavour_middle_tier_flavour').val()
      productProperties['Please select your buttercake flavour - middle tier'] = flavour
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour - middle tier]" value="${flavour}">`)

      if (flavour.includes('[')) {
        customization_total += parseInt(flavour.substring(flavour.indexOf("$") + 1, flavour.lastIndexOf("]")))
      } 
    }

    if (cake_flavour_bottom_tier == true) {
      var flavour = $('#cake_flavour_bottom_tier_flavour').val() 
      productProperties['Please select your buttercake flavour - bottom tier'] = flavour 
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercake flavour - bottom tier]" value="${flavour}">`)

      if (flavour.includes('[')) {
        customization_total += parseInt(flavour.substring(flavour.indexOf("$") + 1, flavour.lastIndexOf("]")))
      } 
    }

    if (birthday_buttercake_filling == true) {
      var filling = $('#birthday_buttercake_filling_option').val() 
      productProperties['Please select your filling'] = filling 
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your filling]" value="${filling}">`)
    }

    if (naked_cake_filling == true) { 
      var filling = $('#naked_cake_filling_option').val() 
      productProperties['Please select your filling'] = filling 
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your filling]" value="${filling}">`)
    }    

    if (chocolate_happy_birthday_plaque == true) {
      var selection = $('#chocolate_happy_birthday_plaque_option').val() 
      productProperties['Would you like a chocolate happy birthday plaque?'] = selection 
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a chocolate happy birthday plaque?]" value="${selection}">`)
    
      if (selection.includes('[')) {
        customization_total += parseInt(selection.substring(selection.indexOf("$") + 1, selection.lastIndexOf("]")))
      } 
    }

    if (drip == true) {
      var drip_selection = $('#drip_option').val() 
      
      productProperties['Would you like a drip?'] = drip_selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a drip?]" value="${drip_selection}">`)

      var drip_colour_option = $('#drip_colour_option').val()
      
      productProperties['What colour drip would you like?'] = drip_colour_option
      $('#custom-options').append(`<input type="hidden" name="properties[What colour drip would you like?]" value="${drip_colour_option}">`)

      if (drip_colour_option == 'Colour [$10]') {
        productProperties['Colour'] = $('#drip_colour_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Colour]" value="${$('#drip_colour_colour_option').val()}">`)
        customization_total += 10
      }

      if ($('#text_on_board_chocolate_colour').val() == 'Gold Drips [$50]') {
        productProperties['Please select your gold drip option'] = $('#drip_colour_golds_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select your gold drip option]" value="${$('#drip_colour_golds_option').val()}">`)
        customization_total += 50
      }
    }

    if (macarons == true) { 
      var macaron_selection = $('#macarons_option').val() 
      
      productProperties['Would you like macarons?'] = macaron_selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like macarons?]" value="${macaron_selection}">`)

      var macarons_qty_option = $('#macarons_qty_option').val()
      
      productProperties['How many macarons would you like?'] = macarons_qty_option
      $('#custom-options').append(`<input type="hidden" name="properties[How many macarons would you like?]" value="${macarons_qty_option}">`)

      if (macarons_qty_option.includes('[')) {
        customization_total += parseInt(macarons_qty_option.substring(macarons_qty_option.indexOf("$") + 1, macarons_qty_option.lastIndexOf("]")))
      } 
      
      macarons_colour_flavour_option = $('#macarons_colour_flavour_option').val()
      
      productProperties['What colour/flavour?'] = macarons_colour_flavour_option
      $('#custom-options').append(`<input type="hidden" name="properties[What colour/flavour?]" value="${macarons_colour_flavour_option}">`)
    }
 
    if (cross_or_name == true) {  
      var cross_or_name_option = $('#cross_or_name_option').val()
      productProperties['Would you like a cross or name for the front in acrylic?'] = cross_or_name_option
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a cross or name for the front in acrylic?]" value="${cross_or_name_option}">`)

      if (cross_or_name_option.includes('[')) {
        customization_total += parseInt(cross_or_name_option.substring(cross_or_name_option.indexOf("$") + 1, cross_or_name_option.lastIndexOf("]")))
      } 

      productProperties['What colour would you like?'] = $('#cross_or_name_colour_option').val() 
      $('#custom-options').append(`<input type="hidden" name="properties[What colour would you like?]" value="${$('#cross_or_name_colour_option').val()}">`)
  
      if (cross_or_name_option == 'A Name [$20]') {
        productProperties['Please type the name here'] = $('#cross_or_name_text_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please type the name here]" value="${$('#cross_or_name_text_option').val()}">`) 
      }
    }

    if (flowers == true) {  
      productProperties['Would you like flowers?'] = $('#flowers_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like flowers?]" value="${$('#flowers_option').val()}">`)

      var flowers_selection = $('#flowers_size_option').val()
      productProperties['Please select the size bouquet flower needed'] = flowers_selection
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the size bouquet flower needed]" value="${flowers_selection}">`)

      if (flowers_selection.includes('[')) {
        customization_total += parseInt(flowers_selection.substring(flowers_selection.indexOf("$") + 1, flowers_selection.lastIndexOf("]")))
      } 

      productProperties['Please type the colour themed you want for the flowers'] = $('#flowers_colour_theme_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please type the colour themed you want for the flowers]" value="${$('#flowers_colour_theme_option').val()}">`)
  
      var flowers_arrangement = $('#flowers_arrangement_option').val()

      productProperties['How would you like your flowers arranged?'] = flowers_arrangement
      $('#custom-options').append(`<input type="hidden" name="properties[Please type the colour themed you want for the flowers]" value="${flowers_arrangement}">`)
      
      if (flowers_arrangement == 'My own way') {
        productProperties['Please explain the arrangement look for your flowers'] = $('#flowers_own_arrangement_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please explain the arrangement look for your flowers]" value="${$('#flowers_own_arrangement_option').val()}">`)
      }
    }

    if (number_of_cookies == true) {
      var selection = $('#number_of_cookies_option').val()
      productProperties['How many cookies would you like?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[How many cookies would you like?]" value="${selection}">`)
  
      if (selection.includes('[')) {
        customization_total += parseInt(selection.substring(selection.indexOf("$") + 1, selection.lastIndexOf("]")))
      } 
    } 

    if (cookies_shape == true) {
      var selection = $('#cookies_shape_option').val()
      productProperties['What shape would your like your cookies?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[What shape would your like your cookies?]" value="${selection}">`)
    } 
  
    if (cookies_stamp == true) { 
      var selection = $('#cookies_stamp_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What stamp would you like on the cookies?]" value="${selection}">`) 

      if (selection == 'Custom Stamp [$35]') {
        customization_total += 35

        var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
        var fileInput = $('#cookies_stamp_image_option').prop('files')
        var attachmentObject = false
        var uploadError = false

        var file_data = $('#cookies_stamp_image_option').prop('files')[0];   
        var form_data = new FormData();                  
        form_data.append('fileInput', file_data); 
        
        if (fileInput.length > 0) {
          await $.ajax({
            url: 'https://custom.fizdigital.online/polesImageUpload.php',
            method: 'POST',
            data: form_data,   
            processData: false,
            contentType: false, 
            success: function (response) {
              var image_url = 'https://custom.fizdigital.online/' + response
              $('#custom-options').append(`<input type="hidden" name="properties[Please upload a sample of the custom stamp you would like]" value="${image_url}">`) 
            }, 
          });
        }
      }
    }

    if (cookies_theme == true) {
      var selection = $('#cookies_theme_option').val()
      productProperties['Please explain here what colour/theme you want the cookies to look like'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Please explain here what colour/theme you want the cookies to look like]" value="${selection}">`)
    }

    if (cookies_foil == true) {
      var selection = $('#cookies_foil_option').val()
      productProperties['Would you like some gold/silver foil?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like some gold/silver foil?]" value="${selection}">`)
  
      if (selection.includes('[')) {
        customization_total += parseInt(selection.substring(selection.indexOf("$") + 1, selection.lastIndexOf("]")))
      } 
    } 

    if (character_name == true) { character_name_option
      productProperties['What character would you like?'] = $('#character_name_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What character would you like?]" value="${$('#character_name_option').val()}">`)
    }
    
    if (brand_of_choice == true) {
      productProperties['Please mention here the brand of your choice'] = $('#brand_of_choice_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please mention here the brand of your choice]" value="${$('#brand_of_choice_option').val()}">`)
    }

    if (minion_character == true) {
      productProperties['Minion character'] = $('#minion_character_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Minion character]" value="${$('#minion_character_option').val()}">`)
    }

    if (cake_team == true) { 
      productProperties['Please mention here the team for your cake'] = $('#cake_team_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please mention here the team for your cake]" value="${$('#cake_team_option').val()}">`)
    }

    if (colour == true) { 
      productProperties['Colour'] = $('#colour_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Colour]" value="${$('#colour_option').val()}">`)
    }

    if (cupcake_theme_colour == true) { 
      productProperties['Please select the main colour of your cupcake theme'] = $('#cupcake_theme_colour_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the main colour of your cupcake theme]" value="${$('#cupcake_theme_colour_option').val()}">`)
    }

    if (hb_round_acrylic_toppers == true) {
      var selection = $('#hb_round_acrylic_toppers_option').val() 
      productProperties['Would you like to add HB round acrylic toppers?'] = selection 
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add HB round acrylic toppers?]" value="${selection}">`)
    
      if (selection.includes('[')) {
        customization_total += parseInt(selection.substring(selection.indexOf("$") + 1, selection.lastIndexOf("]")))
      } 
    }

    if (cashews == true) {   
      productProperties['Would you like to add sprinkles?'] = $('#cashews_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add sprinkles?]" value="${$('#cashews_option').val()}">`)
    } 

    if (glitter == true) {  
      productProperties['Would you like to add glitter?'] = $('#glitter_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add glitter?]" value="${$('#glitter_option').val()}">`)
    } 

    if (gold_leaf == true) {  
      productProperties['Would you like to add gold leaf?'] = $('#gold_leaf_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add gold leaf?]" value="${$('#gold_leaf_option').val()}">`)
    } 
    
    if (colour_swirl == true) {  
      productProperties['Please select your colour swirl'] = $('#colour_swirl_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your colour swirl]" value="${$('#colour_swirl_option').val()}">`)
    } 

    if (cannoli_fillings == true) {  
      productProperties['Please select your fillings'] = $('#cannoli_fillings_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your fillings]" value="${$('#cannoli_fillings_option').val()}">`)
    }

    if (cannoli_colours == true) {
      var cannoli_colour_selection = $('#cannoli_colours_option').val()
      productProperties['What colour would you like?'] = cannoli_colour_selection
      $('#custom-options').append(`<input type="hidden" name="properties[What colour would you like?]" value="${cannoli_colour_selection}">`)
  
      if (cannoli_colour_selection == 'Pastel Colours') { 
        productProperties['Please select one'] = $('#cannoli_pastel_colours_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select one]" value="${$('#cannoli_pastel_colours_option').val()}">`)
      }
  
      if (cannoli_colour_selection == 'Bright Colours') { 
        productProperties['Please select one'] = $('#cannoli_bright_colours_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select one]" value="${$('#cannoli_bright_colours_option').val()}">`)
      }
  
      if (cannoli_colour_selection == 'Dark Colours') { 
        productProperties['Please select one'] = $('#cannoli_dark_colours_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select one]" value="${$('#cannoli_dark_colours_option').val()}">`)
      }
  
      if (cannoli_colour_selection == 'Chocolate Coated (With Strawberries)') { 
        productProperties['Please select one'] = 'Chocolate Coated (With Strawberries)'
        $('#custom-options').append(`<input type="hidden" name="properties[Please select one]" value="Chocolate Coated (With Strawberries)">`)
      }
    }

    if (cannoli_flowers == true) { 
      productProperties['Would you like flowers?'] = $('#cannoli_flowers_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like flowers?]" value="${$('#cannoli_flowers_option').val()}">`)
    }

    if (customised_mini_acrylic_name == true) {
      var selection = $('#customised_mini_acrylic_name_option').val()
      productProperties['Would you like a customised mini acrylic name?'] = selection
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a customised mini acrylic name?]" value="${selection}">`)
  
      if (selection == 'Yes, Please [$15]') { 
        productProperties['Please select your colour'] = $('#customised_mini_acrylic_name_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select your colour]" value="${$('#customised_mini_acrylic_name_colour_option').val()}">`)

        productProperties['Mini acrylic name to read'] = $('#customised_mini_acrylic_name_text_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Mini acrylic name to read]" value="${$('#customised_mini_acrylic_name_text_option').val()}">`)

        customization_total += 15
      } 
    }
    
    if (cheese_cake_topping == true) { 
      productProperties['What topping would you like?'] = $('#cheese_cake_topping_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What topping would you like?]" value="${$('#cheese_cake_topping_option').val()}">`)
    } 

    if (cold_cheese_cake_topping == true) { 
      productProperties['What topping would you like?'] = $('#cold_cheesecake_topping_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What topping would you like?]" value="${$('#cold_cheesecake_topping_option').val()}">`)
    } 

    if (cross == true) { 
      productProperties['Would you like a cross?'] = $('#cross_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like a cross?]" value="${$('#cross_option').val()}">`)
    } 

    if (disney_princess == true) { 
      productProperties['What princess or Barbie would you like?'] = $('#disney_princess_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What princess or Barbie would you like?]" value="${$('#disney_princess_option').val()}">`)
    } 
    
    if (cupcakes_flavour == true) { 
      productProperties['Cupcakes flavour'] = $('#cupcakes_flavour_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Cupcakes flavour]" value="${$('#cupcakes_flavour_option').val()}">`)
    }

    if (cupcakes_text == true) { 
      productProperties['Please type the text for the cupcakes here'] = $('#cupcakes_text_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please type the text for the cupcakes here]" value="${$('#cupcakes_text_option').val()}">`)
    }

    if (cake_drink_inspiration == true) {  
      productProperties['What drink would you like this cake to be inspired on?'] = $('#cake_drink_inspiration_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[What drink would you like this cake to be inspired on?]" value="${$('#cake_drink_inspiration_option').val()}">`)
    }

    if (front_plaque_text == true) { 
      productProperties['Please write here the text on the front plaque'] = $('#front_plaque_text_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please write here the text on the front plaque]" value="${$('#front_plaque_text_option').val()}">`)
    }

    if (name == true) {
      productProperties['Name'] = $('#name').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Name]" value="${$('#name').val()}">`)
    }

    if (age == true) { 
      productProperties['Age'] = $('#age').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Age]" value="${$('#age').val()}">`)
    }

    if (colour_swap == true) {
      productProperties['Please mention here if you wish a colour swap'] = $('#colour_swap').val()  
      $('#custom-options').append(`<input type="hidden" name="properties[Please mention here if you wish a colour swap]" value="${$('#colour_swap').val()}">`)
    }

    if (cake_top_look == true) { 
      productProperties['Please select the look for the top of the cake'] = $('#cake_top_look_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the look for the top of the cake]" value="${$('#cake_top_look_option').val()}">`)
  
      if ($('#cake_top_look_option').val() == 'Full Moon') {
        productProperties['Would you like a HB chocolate sign or a cake topper?'] = $('#cake_top_look_full_moon_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Would you like a HB chocolate sign or a cake topper?]" value="${$('#cake_top_look_full_moon_option').val()}">`)
  
        if ($('#cake_top_look_full_moon_option').val() == 'Chocolate Sign [$5]') {
          customization_total += 5
        }
      }
  
      if ($('#cake_top_look_option').val() == 'Half Moon') {
        productProperties['Would you like to add text on top or a cake topper?'] = $('#cake_top_look_half_moon_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add text on top or a cake topper?]" value="${$('#cake_top_look_half_moon_option').val()}">`)
        
        if ($('#cake_top_look_half_moon_option').val() == 'Text On The Cake') {
          productProperties['Please add your text bellow'] = $('#cake_top_look_text_on_cake_option').val()
          $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#cake_top_look_text_on_cake_option').val()}">`)
        }
      }
    }

    if (strawberries_and_chocolate_curls == true) { 
      productProperties['Would you like to strawberries and chocolate curls on top?'] = $('#strawberries_and_chocolate_curls_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to strawberries and chocolate curls on top?]" value="${$('#strawberries_and_chocolate_curls_option').val()}">`)
    }

    if (sponge_cake_flavours == true) {
      productProperties['Please select your flavour'] = $('#sponge_cake_flavours_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your flavour]" value="${$('#sponge_cake_flavours_option').val()}">`)
    }

    if (sponge_cake_fillings == true) {
      productProperties['Please select your filling'] = $('#sponge_cake_sponge_cake_fillings_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your filling]" value="${$('#sponge_cake_sponge_cake_fillings_option').val()}">`)
    } 

    if (buttercream_outside_colour == true) {
      productProperties['Please select your buttercream outside colour'] = $('#buttercream_outside_colour_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your buttercream outside colour]" value="${$('#buttercream_outside_colour_option').val()}">`)

      if ($('#buttercream_outside_colour_option').val() == 'Colour [$10]') {
        customization_total += 10
        productProperties['Buttercream Colour'] = $('#buttercream_outside_colour_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Buttercream Colour]" value="${$('#buttercream_outside_colour_colour_option').val()}">`)
      }
    }

    if (shell_edge_colour == true) {
      productProperties['Please select your shell edge colour'] = $('#shell_edge_colour_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please select your shell edge colour]" value="${$('#shell_edge_colour_option').val()}">`)

      if ($('#shell_edge_colour_option').val() == 'Colour [$10]') {
        customization_total += 10
        productProperties['Shell Edge Colour'] = $('#shell_edge_colour_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Shell Edge Colour]" value="${$('#shell_edge_colour_colour_option').val()}">`)
      }

      if ($('#shell_edge_colour_option').val() == 'Please match it nicely to the cake themed [$10]') {
        customization_total += 10
      } 
    }

    if (sponge_cake_side_look == true) {
      var side_look = $('#sponge_cake_side_look_option').val()
      productProperties['Please select the side look'] = side_look
      $('#custom-options').append(`<input type="hidden" name="properties[Please select the side look]" value="${side_look}">`) 

      if (side_look.includes('[')) { 
        customization_total += parseInt(side_look.substring(side_look.indexOf("$") + 1, side_look.lastIndexOf("]")))
      } 

      if ($('#sponge_cake_side_look_option').val() == 'Sprinkles') {
        var sprinkles = $('#shell_edge_colour_sprinkles_option').val()
        productProperties['Please select colour sprinkles'] = sprinkles
        $('#custom-options').append(`<input type="hidden" name="properties[Please select colour sprinkles]" value="${sprinkles}">`)

        if (sprinkles.includes('[')) {
          customization_total += parseInt(sprinkles.substring(sprinkles.indexOf("$") + 1, sprinkles.lastIndexOf("]")))
        }

        if (sprinkles == 'Mix Sprinkles [$10]') {
          productProperties['Sprinkles Colour 1'] = $('#shell_edge_colour_sprinkles_sprinkles_one_option').val()
          $('#custom-options').append(`<input type="hidden" name="properties[Sprinkles Colour 1]" value="${$('#shell_edge_colour_sprinkles_sprinkles_one_option').val()}">`)
          
          productProperties['Sprinkles Colour 2'] = $('#shell_edge_colour_sprinkles_sprinkles_two_option').val()
          $('#custom-options').append(`<input type="hidden" name="properties[Sprinkles Colour 2]" value="${$('#shell_edge_colour_sprinkles_sprinkles_two_option').val()}">`)
        }
      }
    }

    if (fondant_or_buttercream == true) {  
      productProperties['Would you like this to be made of Fondant or Buttercream?'] = $('#fondant_or_buttercream_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like this to be made of Fondant or Buttercream?]" value="${$('#fondant_or_buttercream_option').val()}">`)
  
      if ($('#fondant_or_buttercream_option').val() == 'Fondant [$40]') {
        customization_total += 40
      }
    } 

    if (reference_picture == true) {
      var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
      var fileInput = $('#reference_picture_option').prop('files')
      var attachmentObject = false
      var uploadError = false

      var file_data = $('#reference_picture_option').prop('files')[0];   
      var form_data = new FormData();                  
      form_data.append('fileInput', file_data); 
      
      if (fileInput.length > 0) {
        await $.ajax({
          url: 'https://custom.fizdigital.online/polesImageUpload.php',
          method: 'POST',
          data: form_data,   
          processData: false,
          contentType: false, 
          success: function (response) {
            var image_url = 'https://custom.fizdigital.online/' + response
            $('#custom-options').append(`<input type="hidden" name="properties[Reference picture]" value="${image_url}">`) 
          }, 
        });
      }
    }

    if (picture_upload == true) { 
      var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
      var fileInput = $('#picture_upload_option').prop('files')
      var attachmentObject = false
      var uploadError = false

      var file_data = $('#picture_upload_option').prop('files')[0];   
      var form_data = new FormData();                  
      form_data.append('fileInput', file_data); 
      
      if (fileInput.length > 0) {
        await $.ajax({
          url: 'https://custom.fizdigital.online/polesImageUpload.php',
          method: 'POST',
          data: form_data,   
          processData: false,
          contentType: false, 
          success: function (response) {
            var image_url = 'https://custom.fizdigital.online/' + response
            $('#custom-options').append(`<input type="hidden" name="properties[Please upload your picture here]" value="${image_url}">`) 
          }, 
        });
      }
    }
    
    if (photo_upload == true) { 
      var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
      var fileInput = $('#photo_upload_option').prop('files')
      var attachmentObject = false
      var uploadError = false

      var file_data = $('#photo_upload_option').prop('files')[0];   
      var form_data = new FormData();                  
      form_data.append('fileInput', file_data); 
      
      if (fileInput.length > 0) {
        await $.ajax({
          url: 'https://custom.fizdigital.online/polesImageUpload.php',
          method: 'POST',
          data: form_data,   
          processData: false,
          contentType: false, 
          success: function (response) {
            var image_url = 'https://custom.fizdigital.online/' + response
            $('#custom-options').append(`<input type="hidden" name="properties[Please upload your photo here]" value="${image_url}">`) 
          }, 
        });
      }
    }

    if (image_on_top) {
      var image_on_top_option = $('#image_on_top_option').val()
      productProperties['Would you like an image on top of the cake?'] = image_on_top_option
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like an image on top of the cake?]" value="${image_on_top_option}">`) 

      if (image_on_top_option.includes('[')) {
        customization_total += parseInt(image_on_top_option.substring(image_on_top_option.indexOf("$") + 1, image_on_top_option.lastIndexOf("]")))
      } 

      var allowedFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/webp', 'image/avif', 'image/apng', 'image/bmp', 'image/x-icon', 'image/tiff']
      var fileInput = $('#image_on_top_image_option').prop('files')
      var attachmentObject = false
      var uploadError = false

      var file_data = $('#image_on_top_image_option').prop('files')[0];   
      var form_data = new FormData();                  
      form_data.append('fileInput', file_data); 
      
      if (fileInput.length > 0) {
        await $.ajax({
          url: 'https://custom.fizdigital.online/polesImageUpload.php',
          method: 'POST',
          data: form_data,   
          processData: false,
          contentType: false, 
          success: function (response) {
            var image_url = 'https://custom.fizdigital.online/' + response 
            $('#custom-options').append(`<input type="hidden" name="properties[Please upload your picture here]" value="${image_url}">`) 
          }, 
        });
      }
    }

    if (text_on_top_or_cake_topper_text_with_no_colour == true) {
      productProperties['Would you like to add text on top or a cake topper?'] = $('#text_on_top_or_cake_topper_nc_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add text on top or a cake topper?]" value="${$('#text_on_top_or_cake_topper_nc_option').val()}">`)

      if ($('#text_on_top_or_cake_topper_nc_option').val() == 'Text On The Cake') { 
        productProperties['Please add your text bellow'] = $('#text_on_top_or_cake_topper_nc_text_on_cake_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#text_on_top_or_cake_topper_nc_text_on_cake_option').val()}">`)
      }
    }

    if (text_on_top_or_cake_topper_with_text_printed == true) {  
      productProperties['Would you like to add text on top or a cake topper?'] = $('#text_on_top_or_cake_topper_with_text_printed_option').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add text on top or a cake topper?]" value="${$('#text_on_top_or_cake_topper_with_text_printed_option').val()}">`)

      if ($('#text_on_top_or_cake_topper_with_text_printed_option').val() == 'Text On The Cake') { 
        productProperties['Chocolate or colour'] = $('#text_on_top_or_cake_topper_chocolate_or_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Chocolate or colour]" value="${$('#text_on_top_or_cake_topper_chocolate_or_colour_option').val()}">`)

        if ($('#text_on_top_or_cake_topper_chocolate_or_colour_option').val() == 'Colour [$10]') { 
          productProperties['Colour'] = $('#text_on_top_or_cake_topper_colour_option').val()
          $('#custom-options').append(`<input type="hidden" name="properties[Colour]" value="${$('#text_on_top_or_cake_topper_colour_option').val()}">`)

          customization_total += 10 
        }
        
        productProperties['Please add your text bellow'] = $('#text_on_top_or_cake_topper_text_on_cake_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#text_on_top_or_cake_topper_text_on_cake_option').val()}">`)
      }

      if ($('#text_on_top_or_cake_topper_with_text_printed_option').val() == 'Text Printed On Image') {
        productProperties['Please add your text bellow'] = $('#text_on_top_or_cake_topper_text_on_cake_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#text_on_top_or_cake_topper_text_on_cake_option').val()}">`)
      }
    }

    if (text_on_top_or_cake_topper == true) { 
      productProperties['Would you like to add text on top or a cake topper?'] = $('#text_on_top_or_cake_topper_option').val() 
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add text on top or a cake topper?]" value="${$('#text_on_top_or_cake_topper_option').val()}">`)

      if ($('#text_on_top_or_cake_topper_option').val() == 'Text On The Cake') { 
        productProperties['Chocolate or colour'] = $('#text_on_top_or_cake_topper_chocolate_or_colour_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Chocolate or colour]" value="${$('#text_on_top_or_cake_topper_chocolate_or_colour_option').val()}">`)

        if ($('#text_on_top_or_cake_topper_chocolate_or_colour_option').val() == 'Colour [$10]') {
          productProperties['Colour'] = $('#text_on_top_or_cake_topper_colour_option').val()
          $('#custom-options').append(`<input type="hidden" name="properties[Colour]" value="${$('#text_on_top_or_cake_topper_colour_option').val()}">`)

          customization_total += 10 
        }
        
        productProperties['Please add your text bellow'] = $('#text_on_top_or_cake_topper_text_on_cake_option').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#text_on_top_or_cake_topper_text_on_cake_option').val()}">`)
      }
    }

    if (cake_topper == true) {  
      productProperties['Would you like to add a Cake Topper?'] = 'Yes, Please'
      productProperties['What Cake Topper would you like?'] = cake_topper_option
      customization_total += cake_topper_price

      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add a Cake Topper]" value="Yes, Please">`)
      $('#custom-options').append(`<input type="hidden" name="properties[What Cake Topper would you like?]" value="${cake_topper_option}">`)   
  
      if (cake_topper_option == 'Number Topper (Eg. 16) [$30]') {
        productProperties['Cake Topper Number'] = $('#topper_number').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Cake Topper Number]" value="${$('#topper_number').val()}">`)
      }

      if (cake_topper_option == 'Number Letter Topper (Eg. Sixteen) [$30]') {  
        productProperties['Cake Topper Number'] = $('#topper_number_text').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Cake Topper Number]" value="${$('#topper_number_text').val()}">`)
      }

      if (cake_topper_option == 'Customised Cake Topper [$50]') {
        productProperties['What would you like the cake topper to say?'] = $('#customised_topper_text').val()
        $('#custom-options').append(`<input type="hidden" name="properties[What would you like the cake topper to say?]" value="${$('#customised_topper_text').val()}">`)
      }

      if (cake_topper_option == 'Customised Acrylic Name and Age (For the front and or top of the cake) [$40]') {
        productProperties['Customised Acrylic Name'] = $('#customised_acrylic_name').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Customised Acrylic Name]" value="${$('#customised_acrylic_name').val()}">`)
        productProperties['Customised Acrylic Age'] = $('#customised_acrylic_age').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Customised Acrylic Age]" value="${$('#customised_acrylic_age').val()}">`)
      }      

      if ($('#cake_topper_color').val()) {
        productProperties['Cake Topper Color'] = $('#cake_topper_color').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Cake Topper Color]" value="${$('#cake_topper_color').val()}">`)
      } 
    } 

    if (text_on_board == true) {
      var text_on_board_selection = $('#text_on_board_chocolate_colour').val()
      
      productProperties['Would you like to add text on the board?'] = $('#text_on_board_yes_no').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add text on the board?]" value="${$('#text_on_board_yes_no').val()}">`)
      productProperties['Please select between colour or golds'] = text_on_board_selection
      $('#custom-options').append(`<input type="hidden" name="properties[Please select between colour or golds]" value="${text_on_board_selection}">`)

      if ($('#text_on_board_chocolate_colour').val() == 'Colour [$10]') {
        productProperties['Colour'] = $('#text_on_board_colour').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Colour]" value="${$('#text_on_board_colour').val()}">`)
      }

      if ($('#text_on_board_chocolate_colour').val() == 'Golds [$20]') {
        productProperties['Please select the colour'] = $('#text_on_board_gold_colours').val()
        $('#custom-options').append(`<input type="hidden" name="properties[Please select the colour]" value="${$('#text_on_board_gold_colours').val()}">`)
      }

      productProperties['Please add your text bellow'] = $('#text_on_board_text').val()
      $('#custom-options').append(`<input type="hidden" name="properties[Please add your text bellow]" value="${$('#text_on_board_text').val()}">`)

      if (text_on_board_selection != 'Chocolate') { 
         customization_total += parseInt(text_on_board_selection.substring(text_on_board_selection.indexOf("$") + 1, text_on_board_selection.lastIndexOf("]"))) 
      }
    }
    
    if (candles == true) {
      productProperties['Would you like to add candles?'] = $('#candles').val() 
      $('#custom-options').append(`<input type="hidden" name="properties[Would you like to add candles?]" value="${$('#candles').val()}">`)
      
      if ($('#candles_white').val() > 0) { 
        var total_white_candles = $('#candles_white').val() * 10
        var white_candles = $('#candles_white').val() + ' [$' + total_white_candles + ']' 
        productProperties['White Candles 12 Pack'] = white_candles
        $('#custom-options').append(`<input type="hidden" name="properties[White Candles 12 Pack]" value="${white_candles}">`) 

        customization_total += total_white_candles
      }

      if ($('#candles_silver').val() > 0) { 
        var total_silver_candles = $('#candles_silver').val() * 10
        var silver_candles = $('#candles_silver').val() + ' [$' + total_silver_candles + ']' 
        productProperties['Silver Candles 12 Pack'] = silver_candles
        $('#custom-options').append(`<input type="hidden" name="properties[Silver Candles 12 Pack]" value="${silver_candles}">`) 

        customization_total += total_silver_candles
      }

      if ($('#candles_gold').val() > 0) { 
        var total_gold_candles = $('#candles_gold').val() * 10
        var gold_candles = $('#candles_gold').val() + ' [$' + total_gold_candles + ']' 
        productProperties['Gold Candles 12 Pack'] = gold_candles
        $('#custom-options').append(`<input type="hidden" name="properties[Gold Candles 12 Pack]" value="${gold_candles}">`) 

        customization_total += total_gold_candles
      }

      if ($('#candles_rose_gold').val() > 0) { 
        var total_rose_gold_candles = $('#candles_rose_gold').val() * 10
        var rose_gold_candles = $('#candles_rose_gold').val() + ' [$' + total_rose_gold_candles + ']' 
        productProperties['Rose Gold Candles 12 Pack'] = rose_gold_candles
        $('#custom-options').append(`<input type="hidden" name="properties[Rose Gold Candles 12 Pack]" value="${rose_gold_candles}">`) 

        customization_total += total_rose_gold_candles
      }

      if ($('#candles_black').val() > 0) { 
        var total_black_candles = $('#candles_black').val() * 10
        var black_candles = $('#candles_black').val() + ' [$' + total_black_candles + ']' 
        productProperties['Black Candles 12 Pack'] = black_candles
        $('#custom-options').append(`<input type="hidden" name="properties[Black Candles 12 Pack]" value="${black_candles}">`) 

        customization_total += total_black_candles
      }   
    }

    if (customization_total > 0) {
      productProperties['_customization_total'] = customization_total
      $('#custom-options').append(`<input type="hidden" name="properties[_customization_total]" value="${customization_total}">`)
    }

    var isValid = true

    $($('.is-required')).each(function() {
      if (!$(this).val().length) {
        $('#custom-options-validation').show()
        isValid = false
      } 
    })  

    if (isValid) {
      var productTitle = $('.product-single__title').text() 
      if (productTitle == 'Single Tier Naked Cake' || productTitle == 'Double Height Naked Cake' || productTitle == 'Double Tier Naked Cake') {
        var selectedOptions = 0
        $('select').each(function(index) {
          if ($('select')[index].value == 'Yes, Please') {
            selectedOptions += 1
          } 
        })
        
        if (selectedOptions >= 2) {
          $('.product-form__cart-submit').click() 
        } else {
          $('.naked-cake-options').show()
        } 
      } else {
        if ($('#candles').val() == 'Yes, Please') {
          if (
            ($('#candles_white').val().length && $('#candles_white').val() != 0) ||  
            ($('#candles_silver').val().length && $('#candles_silver').val() != 0) ||  
            ($('#candles_gold').val().length && $('#candles_gold').val() != 0) || 
            ($('#candles_rose_gold').val().length && $('#candles_rose_gold').val() != 0) || 
            ($('#candles_black').val().length && $('#candles_black').val() != 0)) {
              $('.product-form__cart-submit').click()  
          } else {
            $('.candles-options').show()
          }
        } else if ($('#image_on_top_option').val() == 'Yes, Please [$30]') {
          if ($('#image_on_top_image_option')[0].files.length != 0) { 
            $('.product-form__cart-submit').click()   
          } else {
            $('.image-option').show()   
          }
        } else {
          $('.product-form__cart-submit').click() 
        }
      }
      /*$.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/add.js',
        dataType: "json", 
        data: { 
          quantity: 1,
          id: variants[0].id,
          properties: productProperties 
        }, 
        success: function(result) {  
          window.location.href = '/cart' 
        } 
      })*/
    }
  } 
  
  $('#custom-add-to-cart').click(function() {
    saveOrder()
  })
})